import React__default, { useState, useRef, useCallback, useEffect, useMemo, createElement, Fragment } from 'react';
import { responsiveFontSizes, createTheme, useTheme, ThemeProvider, styled as styled$1 } from '@mui/material/styles';
import store from 'store2';
import jwt_decode from 'jwt-decode';
import Cookies from 'js-cookie';
import throttle from 'lodash-es/throttle';
import { trackEvent } from '@raisin/events-tracking';
import axios from 'axios';
import qs from 'query-string';
import { useMediaQuery, Snackbar as Snackbar$1, Button as Button$1, Typography as Typography$1, IconButton as IconButton$1, Box, ClickAwayListener, Tooltip as Tooltip$1, Stack, Divider } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CloseIcon$1 from '@mui/icons-material/Close';
import xss from 'xss';
import styled, { css } from 'styled-components';
import CheckIcon from '@mui/icons-material/Check';
import Skeleton$2 from '@mui/material/Skeleton';
import Link from '@mui/material/Link';
import isEmpty from 'lodash.isempty';
import Button$2 from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import compact from 'lodash.compact';
import { withTheme, withStyles } from '@mui/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import IBAN from 'iban';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import Fade from '@mui/material/Fade';
import Badge from '@mui/material/Badge';
import IconButton$2 from '@mui/material/IconButton';
import Box$1 from '@mui/material/Box';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

var EventAction;
(function (EventAction) {
  EventAction["SESSION_EXPIRED"] = "expired";
  EventAction["SESSION_EXTENDED_AUTOMATICALLY"] = "extended-automatically";
  EventAction["SESSION_EXTENDED_MANUALLY"] = "extended-manually";
  EventAction["SESSION_COUNTDOWN_SHOWN"] = "shown";
})(EventAction || (EventAction = {}));

var LocalStorageKey;
(function (LocalStorageKey) {
  /**
   * A boolean flag to determine if we need to enable session-timeout feature on localhost or not.
   * Default value is false.
   */
  LocalStorageKey["ENABLE_LOCAL_SESSION_TIMEOUT"] = "enable_local_session_timeout";
  /**
   * A number indicates the last active time of the user in any opened session.
   * It is being updated on each user activity (click, type), which are debounced for 1 second.
   */
  LocalStorageKey["LAST_ACTIVE_TIME"] = "last_active_time";
  LocalStorageKey["AUTH_TOKEN"] = "auth_token";
  LocalStorageKey["AUTH_CONFIG_DONE"] = "auth_config_done";
  LocalStorageKey["AUTH_TIME_DIFF"] = "auth_time_diff";
  //TAMS accounts and transaction account data key stored in the local storage, needed to remove them after logout
  LocalStorageKey["ACCOUNTS"] = "/accounts";
  LocalStorageKey["TRANSACTION_ACCOUNT"] = "accounts/TRA";
  LocalStorageKey["COUNTDOWN_TIMESTAMP"] = "lastSyncedAutoLogoutTimestampRefresh";
})(LocalStorageKey || (LocalStorageKey = {}));
var CookieKey;
(function (CookieKey) {
  CookieKey["OBS_SESSION"] = "obs-session";
})(CookieKey || (CookieKey = {}));

var COUNTRIES_ISO_3 = {
  AUT: 'AUT',
  DEU: 'DEU',
  ESP: 'ESP',
  FRA: 'FRA',
  GBR: 'GBR',
  IRL: 'IRL',
  NLD: 'NLD'
};
var REGIONS = {
  DEU: 'DEU',
  GBR: 'GBR'
};

/**
 *  Time in seconds before session expiration to display the countdown notification
 */
var SESSION_EXPIRATION_COUNTDOWN_TIME = 120;
/**
 * The visibility duration of the session extended/refreshed message
 */
var SESSION_EXTENDED_MESSAGE_AUTO_HIDE_DURATION = 5000;
// A buffer in seconds to check if current token is a new login
var NEW_LOGIN_ISSUANCE_BUFFER = 5;

// TODO: Change the name after OBS is retired
var LOGIN_REFERRER_KEY = 'obs-deepLink';

var LOGIN_CLIENT_ID = 'login';

var MOBILE_WEBVIEW_IDENTIFIER = 'webview';
var COOKIE_FOR_MOBILE_NAME = 'mobile';

var LINKS = {
  LOGIN: '/login'
};

var EnvironmentTypes;
(function (EnvironmentTypes) {
  EnvironmentTypes["DEVELOPMENT"] = "development";
  EnvironmentTypes["STAGING"] = "staging";
  EnvironmentTypes["ONBOARDING"] = "onboarding";
  EnvironmentTypes["PRODUCTION"] = "production";
  EnvironmentTypes["AMPLIFY_APP"] = "amplifyapp";
  EnvironmentTypes["LOCAL"] = "local";
})(EnvironmentTypes || (EnvironmentTypes = {}));

var microservices = {
  keycloak: {
    GBR: {
      local: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
      development: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
      staging: 'https://auth.staging-raisin.co.uk/auth/realms/global',
      onboarding: 'https://auth.onboarding-raisin.co.uk/auth/realms/global',
      production: 'https://auth.raisin.co.uk/auth/realms/global'
    },
    DEU: {
      local: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
      development: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
      staging: 'https://auth.staging-weltsparen.de/auth/realms/global',
      onboarding: 'https://auth.onboarding-weltsparen.de/auth/realms/global',
      production: 'https://auth.weltsparen.de/auth/realms/global'
    }
  }
};

/**
 * Checks if the current environment is rendered by client-side
 */
var isCSR = function isCSR() {
  return typeof window !== 'undefined';
};
var getDomain = function getDomain() {
  var _window;
  var domainParts = (_window = window) == null ? void 0 : _window.location.host.split('.');
  domainParts.shift();
  /**
   * Set the 'domain' attribute of the cookie to e.g. ".weltsparen.de",
   * so it is also accessible on Public Website
   *
   * or
   *
   * set it to whatever the domain is, if on localhost
   */
  return domainParts.length <= 1 ? '' : "." + domainParts.join('.');
};
var getLocale = function getLocale() {
  if (isCSR()) {
    var _window$location = window.location,
      host = _window$location.host,
      pathname = _window$location.pathname;
    if (host.endsWith('.de') || host.endsWith('.at')) return 'de';
    if (host.endsWith('.co.uk') || host.endsWith('.ie')) return 'en';
    if (host.endsWith('.com')) {
      var _pathname$split$;
      var localePrefix = (_pathname$split$ = pathname.split('/')[1]) != null ? _pathname$split$ : '';
      switch (localePrefix.toLowerCase()) {
        case 'pl-pl':
          return 'pl';
        case 'fi-fi':
          return 'fi';
        case 'fr-fr':
          return 'fr';
        case 'de-de':
        case 'de-at':
          return 'de';
        case 'es-es':
          return 'es';
        case 'nl-nl':
          return 'nl';
        case 'en-gb':
        case 'en-ie':
        default:
          return 'en';
      }
    }
    if (host.endsWith('.es')) return 'es';
    if (host.endsWith('.fr')) return 'fr';
    if (host.endsWith('.nl')) return 'nl';
  }
  return 'de';
};
var getNamespaceName = function getNamespaceName() {
  if (isCSR()) {
    var name = /bk-(deu|gbr)-(.*)\.raisin-dev\.network/.exec(window.location.host);
    return name ? name[2] : EnvironmentTypes.DEVELOPMENT;
  }
  return EnvironmentTypes.DEVELOPMENT;
};
var getRegionFromHost = function getRegionFromHost() {
  var _window2, _window2$location, _window2$location$hos;
  return isCSR() && (_window2 = window) != null && (_window2$location = _window2.location) != null && (_window2$location$hos = _window2$location.hostname) != null && _window2$location$hos.endsWith('.co.uk') ? COUNTRIES_ISO_3.GBR : COUNTRIES_ISO_3.DEU;
};
var checkHost = function checkHost(host) {
  var _window$location$host;
  return isCSR() && ((_window$location$host = window.location.host) == null ? void 0 : _window$location$host.includes(host));
};
var getEnvironment = function getEnvironment() {
  if (checkHost(EnvironmentTypes.STAGING)) return EnvironmentTypes.STAGING;
  if (checkHost(EnvironmentTypes.ONBOARDING)) return EnvironmentTypes.ONBOARDING;
  if (checkHost(EnvironmentTypes.PRODUCTION)) return EnvironmentTypes.PRODUCTION;
  if (checkHost(EnvironmentTypes.AMPLIFY_APP)) return EnvironmentTypes.DEVELOPMENT;
  if (checkHost('raisin-dev.network')) return getNamespaceName();
  if (checkHost('localhost')) return EnvironmentTypes.LOCAL;
  return EnvironmentTypes.PRODUCTION;
};
var isLocalEnv = function isLocalEnv() {
  return getEnvironment() === EnvironmentTypes.LOCAL;
};
var getUnixTime = function getUnixTime(buffer) {
  if (buffer === void 0) {
    buffer = 0;
  }
  return Math.round(Date.now() / 1000 + buffer);
};
var DEVELOPMENT_ENV_DOMAIN_REGION_REGEX = /bk-(deu|gbr)-(.*)\.raisin-dev\.network/;
var getRegionName = function getRegionName() {
  var _window3, _window3$location;
  var hostname = (_window3 = window) == null ? void 0 : (_window3$location = _window3.location) == null ? void 0 : _window3$location.hostname;
  var developmentName = DEVELOPMENT_ENV_DOMAIN_REGION_REGEX.exec(hostname);
  if (developmentName) {
    return developmentName[1].toUpperCase();
  }
  return hostname != null && hostname.endsWith('.co.uk') ? REGIONS.GBR : REGIONS.DEU;
};
var getMicroServiceBaseUrl = function getMicroServiceBaseUrl(microserviceName) {
  var _microservices$micros;
  var environment = getEnvironment();
  var region = getRegionName();
  if (microservices != null && (_microservices$micros = microservices[microserviceName]) != null && _microservices$micros[region]) {
    return microservices[microserviceName][region][environment];
  }
  return microservices[microserviceName][environment];
};

var getAccessToken = function getAccessToken() {
  if (!isCSR()) return;
  try {
    var _store;
    var token = (_store = store(LocalStorageKey.AUTH_TOKEN)) == null ? void 0 : _store.access_token;
    return jwt_decode(token);
  } catch (error) {
    console.error(error);
  }
  return;
};
var getTokenExpirationTime = function getTokenExpirationTime() {
  try {
    if (isLocalEnv()) return getUnixTime(4 * 60 - 20);
    var token = getAccessToken();
    if (token) return token.exp;
  } catch (error) {
    console.error(error);
  }
  return 0;
};
var getTokenIssuanceTime = function getTokenIssuanceTime() {
  try {
    if (isLocalEnv()) return getUnixTime(-20);
    var token = getAccessToken();
    if (token) return token.iat;
  } catch (error) {
    console.error(error);
  }
  return 0;
};
var getAuthTimeDiff = function getAuthTimeDiff() {
  var _store2;
  if (isLocalEnv()) return getUnixTime(-getTokenIssuanceTime());
  return (_store2 = store(LocalStorageKey.AUTH_TIME_DIFF)) != null ? _store2 : 0;
};
var isAuthenticated = function isAuthenticated() {
  var token = getAccessToken();
  if (!token || token.exp < getUnixTime() - getAuthTimeDiff()) return false;
  return true;
};
/**
 * Get the current session lifespan in minutes
 *
 * It subtracts the token's `issuance-time` from the token's `expiration-time`
 */
var getSessionLifespan = function getSessionLifespan() {
  try {
    var sessionTime = getTokenExpirationTime() - getTokenIssuanceTime();
    return Math.trunc(sessionTime / 60);
  } catch (error) {
    console.error(error);
  }
  return 5;
};
var getRefreshToken = function getRefreshToken() {
  var authToken = store(LocalStorageKey.AUTH_TOKEN);
  return authToken == null ? void 0 : authToken.refresh_token;
};

var setLoginReferer = function setLoginReferer() {
  if (!isCSR()) return;
  var referer = window.location.pathname + window.location.search + window.location.hash;
  // store2 internally call JSON.stringify which adds unwanted quotes to string so localStorage is used
  sessionStorage.setItem(LOGIN_REFERRER_KEY, referer);
};
var deleteCookieForSession = function deleteCookieForSession() {
  return Cookies.remove(CookieKey.OBS_SESSION, {
    path: '/',
    domain: getDomain()
  });
};
var hasCookieForSession = function hasCookieForSession() {
  var cookie = Cookies.get(CookieKey.OBS_SESSION);
  return !!cookie && cookie === 'true';
};

/**
 * Determines if the current page is being rendered within the mobile application (WebView).
 *
 * If the cookies object contains this key "mobile" with value "true", then it is a mobile application.
 *
 * @returns true or false
 */
var isOnMobileApp = function isOnMobileApp() {
  return Cookies.get(COOKIE_FOR_MOBILE_NAME) === 'true';
};

var getLocaleBasePath = function getLocaleBasePath(locale) {
  var UNIFIED_DOMAINS = {
    fr: 'fr-fr',
    de: 'de-de',
    at: 'de-at',
    es: 'es-es',
    nl: 'nl-nl',
    gb: 'en-gb',
    ie: 'en-ie'
  };
  var normalizedLocale = locale.toLowerCase();
  for (var _i = 0, _Object$entries = Object.entries(UNIFIED_DOMAINS); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (normalizedLocale.includes(key)) {
      var _window$location$host;
      if (typeof window !== 'undefined' && (_window$location$host = window.location.hostname) != null && _window$location$host.includes('.com')) {
        return value;
      }
    }
  }
  switch (normalizedLocale.toLowerCase()) {
    case 'pl-pl':
      return 'pl-pl';
    case 'fi-fi':
      return 'fi-fi';
    case 'en':
    case 'en-us':
      return 'en';
    default:
      return '';
  }
};
var getRoutePathWithLocalePrefix = function getRoutePathWithLocalePrefix(_ref) {
  var path = _ref.path,
    _ref$fallbackLocale = _ref.fallbackLocale,
    fallbackLocale = _ref$fallbackLocale === void 0 ? 'de-de' : _ref$fallbackLocale;
  var locale = isCSR() ? document.documentElement.lang : fallbackLocale;
  var localeBasePath = getLocaleBasePath(locale);
  var routePath = path.startsWith('/') ? path : "/" + path;
  return localeBasePath !== '' ? "/" + localeBasePath + routePath : routePath;
};
var goTo = function goTo(path) {
  var _window, _window$location;
  var relativePath = getRoutePathWithLocalePrefix({
    path: path
  });
  (_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.assign(relativePath);
};
var goToLoginPage = function goToLoginPage() {
  if (!isCSR()) return;
  goTo(LINKS.LOGIN);
};

var deleteAuthToken = function deleteAuthToken() {
  store.local.remove(LocalStorageKey.AUTH_TOKEN);
};
var removeAutoLogoutTimestamp = function removeAutoLogoutTimestamp() {
  store.local.remove(LocalStorageKey.COUNTDOWN_TIMESTAMP);
};
var storeAuthConfigDone = function storeAuthConfigDone(value) {
  store.local.set(LocalStorageKey.AUTH_CONFIG_DONE, value);
};
var cleanUpAuthData = function cleanUpAuthData() {
  deleteCookieForSession();
  removeAutoLogoutTimestamp();
  deleteAuthToken();
  storeAuthConfigDone(false);
  store.local.remove(LocalStorageKey.AUTH_TIME_DIFF);
};
var cleanUpSessionData = function cleanUpSessionData() {
  cleanUpAuthData();
  ['/transaction_account', '/customer', '/customer/product/access', '/branding', '/deposits/types', '/threads/unread-count', '/accounts', '/pension/customer/products', '/products', '/product_instances'].concat(store.keys().filter(function (item) {
    return item.includes('/accounts/TRA');
  }), store.keys().filter(function (item) {
    return item.includes('/customers/');
  })).forEach(function (item) {
    store.local.remove(item || '');
  });
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var Service;
(function (Service) {
  /**
   *  Keycloak Service
   */
  Service["KEYCLOAK"] = "keycloak";
})(Service || (Service = {}));

/**
 * This file is the single source of truth for all tracking-events of this zone.
 * All events MUST be included here and the custom-attributes/dynamic data can be overridden
 * whenever necessary in the place of usage.
 *
 * e.g.:https://gitlab.com/raisin-global/raisin-gmbh/banking/raisin-frontend/-/merge_requests/2428
 */
var EVENTS = {
  LOGOUT_SUCCEEDED: {
    eventName: 'logout-succeeded',
    object: 'logout',
    action: 'succeeded',
    description: 'logout-succeeded on the logout-countdown inside customer-portal',
    portal: 'customer-portal',
    boundedContext: 'strong-customer-auth',
    zone: 'customer-portal',
    component: 'logout-countdown'
  },
  REFRESH_TOKEN_EXPIRED: {
    eventName: 'session-refresh-token-expired',
    object: 'session-refresh-token',
    action: 'expired',
    description: 'session-refresh-token-expired on the logout-countdown inside customer-portal',
    portal: 'customer-portal',
    boundedContext: 'customer-advisory',
    zone: 'customer-portal',
    component: 'logout-countdown'
  },
  REFRESH_TOKEN_FAILED: {
    eventName: 'session-refresh-token-failed',
    object: 'session-refresh-token',
    action: 'failed',
    description: 'session-refresh-token-failed on the logout-countdown inside customer-portal',
    portal: 'customer-portal',
    boundedContext: 'customer-advisory',
    zone: 'customer-portal',
    component: 'logout-countdown'
  },
  REFRESH_TOKEN_SUCCEEDED: {
    eventName: 'session-refresh-token-succeeded',
    object: 'session-refresh-token',
    action: 'succeeded',
    description: 'session-refresh-token-succeeded on the logout-countdown',
    portal: 'customer-portal',
    boundedContext: 'customer-advisory',
    zone: 'customer-portal',
    component: 'logout-countdown'
  }
};
var createLogOutSucceededEvent = function createLogOutSucceededEvent(_ref) {
  var zone = _ref.zone;
  return _extends({}, EVENTS.LOGOUT_SUCCEEDED, {
    zone: zone != null ? zone : 'customer-portal'
  });
};

var OBS_API_BASE_URL = /*#__PURE__*/isCSR() ? window.location.origin + "/savingglobal/rest/open_api/v2" : '';
var logout = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post(OBS_API_BASE_URL + "/logout");
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function logout() {
    return _ref.apply(this, arguments);
  };
}();
var keycloakLogout = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(refreshToken) {
    var data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            data = qs.stringify({
              refresh_token: refreshToken,
              client_id: LOGIN_CLIENT_ID
            });
            _context2.next = 3;
            return axios.post(getMicroServiceBaseUrl(Service.KEYCLOAK) + "/protocol/openid-connect/logout", data, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            });
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function keycloakLogout(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var refreshJSessionId = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
    var userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout, platform, refreshToken;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            userManagementCallObsLogout = _ref3.userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout = _ref3.umtFECallKeycloakLogoutOnSessionTimeout, platform = _ref3.platform;
            if (!isLocalEnv()) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            _context3.prev = 3;
            _context3.next = 6;
            return axios.get(OBS_API_BASE_URL + "/customer");
          case 6:
            _context3.next = 19;
            break;
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](3);
            if (!userManagementCallObsLogout) {
              _context3.next = 14;
              break;
            }
            if (!hasCookieForSession()) {
              _context3.next = 14;
              break;
            }
            _context3.next = 14;
            return logout();
          case 14:
            refreshToken = getRefreshToken();
            if (!(umtFECallKeycloakLogoutOnSessionTimeout && refreshToken)) {
              _context3.next = 18;
              break;
            }
            _context3.next = 18;
            return keycloakLogout(refreshToken);
          case 18:
            trackEvent(createLogOutSucceededEvent({
              zone: platform
            }), true);
          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 8]]);
  }));
  return function refreshJSessionId(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var createSessionTrackEventProps = function createSessionTrackEventProps(action, zone, props) {
  if (zone === void 0) {
    zone = 'customer-portal';
  }
  if (props === void 0) {
    props = {};
  }
  return _extends({
    eventName: "session-" + action,
    object: 'session',
    action: action,
    portal: 'customer-portal',
    description: "session-" + action + " in " + zone,
    zone: zone,
    boundedContext: 'customer-advisory'
  }, props);
};

var createClient = function createClient(baseURL, additionalHeaders) {
  return axios.create({
    baseURL: baseURL,
    timeout: 3000,
    headers: _extends({
      'Content-Type': 'application/json'
    }, additionalHeaders)
  });
};

var authConfig = {
  DEU: {
    local: 'https://auth-deu-development.raisin-dev.network/',
    development: 'https://auth-deu-development.raisin-dev.network/',
    staging: 'https://auth.staging-weltsparen.de/',
    onboarding: 'https://auth.onboarding-weltsparen.de/',
    production: 'https://auth.weltsparen.de/',
    namespace: function namespace(name) {
      return "https://auth-deu-" + name + ".raisin-dev.network/";
    }
  },
  GBR: {
    local: 'https://auth-gbr-development.raisin-dev.network/',
    development: 'https://auth-gbr-development.raisin-dev.network/',
    staging: 'https://auth.staging-raisin.co.uk/',
    onboarding: 'https://auth.onboarding-raisin.co.uk/',
    production: 'https://auth.raisin.co.uk/',
    namespace: function namespace(name) {
      return "https://auth-gbr-" + name + ".raisin-dev.network/";
    }
  }
};
var getAuthBaseUrl = function getAuthBaseUrl() {
  var environment = getEnvironment();
  var region = getRegionFromHost();
  return authConfig[region][environment] || authConfig[region].namespace(environment);
};

var AUTH_BASE_URL = /*#__PURE__*/getAuthBaseUrl();
var authService = /*#__PURE__*/createClient(AUTH_BASE_URL);
var refreshTokenPostCall = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(refreshToken, clientId) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", authService({
              method: 'post',
              url: 'auth/realms/global/protocol/openid-connect/token',
              data: qs.stringify({
                grant_type: 'refresh_token',
                client_id: clientId || 'login',
                refresh_token: refreshToken
              }),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function refreshTokenPostCall(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var logOutTheCustomer = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout, platform, refreshToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userManagementCallObsLogout = _ref.userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout = _ref.umtFECallKeycloakLogoutOnSessionTimeout, platform = _ref.platform;
            _context.prev = 1;
            refreshToken = getRefreshToken();
            if (!(umtFECallKeycloakLogoutOnSessionTimeout && refreshToken)) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return keycloakLogout(refreshToken);
          case 6:
            if (!userManagementCallObsLogout) {
              _context.next = 9;
              break;
            }
            _context.next = 9;
            return logout();
          case 9:
            trackEvent(createLogOutSucceededEvent({
              zone: platform
            }), true);
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            if (!(_context.t0 instanceof Error)) {
              _context.next = 16;
              break;
            }
            throw new Error(_context.t0.message);
          case 16:
            _context.prev = 16;
            cleanUpSessionData();
            if (isCSR()) {
              goToLoginPage();
            }
            return _context.finish(16);
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12, 16, 20]]);
  }));
  return function logOutTheCustomer(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getKeycloakToken = function getKeycloakToken() {
  var keyCloakTokenObj = isCSR() ? store(LocalStorageKey.AUTH_TOKEN) : null;
  var keyCloakAccessToken = keyCloakTokenObj ? keyCloakTokenObj.access_token : null;
  var keyCloakRefreshToken = keyCloakTokenObj ? keyCloakTokenObj.refresh_token : null;
  return {
    keyCloakTokenObj: keyCloakTokenObj,
    keyCloakRefreshToken: keyCloakRefreshToken,
    keyCloakAccessToken: keyCloakAccessToken
  };
};
var refreshJWT = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
    var userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout, platform, _getKeycloakToken, keyCloakTokenObj, keyCloakRefreshToken, keyCloakAccessToken, _store, _jwt_decode, exp, azp, timeDiff, res, _jwt_decode2, iat, _timeDiff;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            userManagementCallObsLogout = _ref3.userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout = _ref3.umtFECallKeycloakLogoutOnSessionTimeout, platform = _ref3.platform;
            if (!isLocalEnv()) {
              _context2.next = 4;
              break;
            }
            setTimeout(function () {
              return Promise.resolve();
            }, 500);
            return _context2.abrupt("return");
          case 4:
            _getKeycloakToken = getKeycloakToken(), keyCloakTokenObj = _getKeycloakToken.keyCloakTokenObj, keyCloakRefreshToken = _getKeycloakToken.keyCloakRefreshToken, keyCloakAccessToken = _getKeycloakToken.keyCloakAccessToken;
            if (!(keyCloakAccessToken && keyCloakRefreshToken)) {
              _context2.next = 30;
              break;
            }
            _jwt_decode = jwt_decode(keyCloakAccessToken), exp = _jwt_decode.exp, azp = _jwt_decode.azp;
            timeDiff = (_store = store(LocalStorageKey.AUTH_TIME_DIFF)) != null ? _store : 0;
            if (!(exp < getUnixTime(-timeDiff))) {
              _context2.next = 13;
              break;
            }
            trackEvent(EVENTS.REFRESH_TOKEN_EXPIRED, true);
            _context2.next = 12;
            return logOutTheCustomer({
              userManagementCallObsLogout: userManagementCallObsLogout,
              umtFECallKeycloakLogoutOnSessionTimeout: umtFECallKeycloakLogoutOnSessionTimeout,
              platform: platform
            });
          case 12:
            throw new Error('Refresh token expired!');
          case 13:
            _context2.prev = 13;
            _context2.next = 16;
            return refreshTokenPostCall(keyCloakRefreshToken, azp);
          case 16:
            res = _context2.sent;
            store(LocalStorageKey.AUTH_TOKEN, _extends({}, keyCloakTokenObj, {
              access_token: res.data.access_token,
              refresh_token: res.data.refresh_token
            }));
            _jwt_decode2 = jwt_decode(res.data.access_token), iat = _jwt_decode2.iat;
            _timeDiff = getUnixTime(-iat);
            store(LocalStorageKey.AUTH_TIME_DIFF, _timeDiff);
            trackEvent(EVENTS.REFRESH_TOKEN_SUCCEEDED, true);
            _context2.next = 30;
            break;
          case 24:
            _context2.prev = 24;
            _context2.t0 = _context2["catch"](13);
            trackEvent(EVENTS.REFRESH_TOKEN_FAILED, true);
            _context2.next = 29;
            return logOutTheCustomer({
              userManagementCallObsLogout: userManagementCallObsLogout,
              umtFECallKeycloakLogoutOnSessionTimeout: umtFECallKeycloakLogoutOnSessionTimeout,
              platform: platform
            });
          case 29:
            throw new Error('Refresh token failed!');
          case 30:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[13, 24]]);
  }));
  return function refreshJWT(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var useCountdownNew = function useCountdownNew(_ref) {
  var _flags$userManagement, _flags$umtCallOBSLogi, _flags$umtFECallKeycl, _flags$umtStopRefresh;
  var platform = _ref.platform,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    flags = _ref.flags;
  var _useState = useState({
      timeDiff: 0,
      expiration: 0,
      issuance: 0,
      session: 0
    }),
    tokenTimes = _useState[0],
    setTokenTimes = _useState[1];
  var countdownInterval = useRef();
  var _useState2 = useState(false),
    isTokenRefreshing = _useState2[0],
    setIsTokenRefreshing = _useState2[1];
  var _useState3 = useState('--:--'),
    countdown = _useState3[0],
    setCountdown = _useState3[1];
  var _useState4 = useState(false),
    isSessionCountdownMsgOpened = _useState4[0],
    setIsSessionCountdownMsgOpened = _useState4[1];
  var _useState5 = useState(false),
    isSessionExtendedMsgOpened = _useState5[0],
    setIsSessionExtendedMsgOpened = _useState5[1];
  var _useState6 = useState(true),
    isSessionExtendable = _useState6[0],
    setIsSessionExtendable = _useState6[1];
  var _useState7 = useState(function () {
      return getUnixTime();
    }),
    lastActiveTime = _useState7[0],
    setLastActiveTime = _useState7[1];
  var userManagementCallObsLogout = (_flags$userManagement = flags == null ? void 0 : flags.userManagementCallObsLogout) != null ? _flags$userManagement : false;
  var umtCallOBSLoginEndpointFromFE = (_flags$umtCallOBSLogi = flags == null ? void 0 : flags.umtCallOBSLoginEndpointFromFE) != null ? _flags$umtCallOBSLogi : false;
  var umtFECallKeycloakLogoutOnSessionTimeout = (_flags$umtFECallKeycl = flags == null ? void 0 : flags.umtFECallKeycloakLogoutOnSessionTimeout) != null ? _flags$umtFECallKeycl : false;
  var umtStopRefreshingTokenWhenAboutToReachMaxSession = (_flags$umtStopRefresh = flags == null ? void 0 : flags.umtStopRefreshingTokenWhenAboutToReachMaxSession) != null ? _flags$umtStopRefresh : false;
  var updateTokenTimes = useCallback(function () {
    var timeDiff = getAuthTimeDiff();
    var issuance = getTokenIssuanceTime();
    var expiration = getTokenExpirationTime();
    var session = expiration - issuance;
    var times = {
      timeDiff: timeDiff,
      expiration: expiration,
      issuance: issuance,
      session: session
    };
    setTokenTimes(times);
    return times;
  }, []);
  var initialize = useCallback(function () {
    var _updateTokenTimes = updateTokenTimes(),
      issuance = _updateTokenTimes.issuance,
      timeDiff = _updateTokenTimes.timeDiff;
    if (getUnixTime(-timeDiff) - issuance < NEW_LOGIN_ISSUANCE_BUFFER) {
      setLastActiveTime(issuance + timeDiff);
    } else {
      setLastActiveTime(getUnixTime());
    }
  }, [setLastActiveTime, updateTokenTimes]);
  var trackSessionEvent = useCallback(function (action, props) {
    if (props === void 0) {
      props = {};
    }
    return trackEvent(createSessionTrackEventProps(action, platform, props), true);
  }, [platform]);
  var updateCountdown = useCallback(function (count) {
    var minutesRaw = Math.floor(count / 60);
    var secondsRaw = count - minutesRaw * 60;
    var minutes = ("0" + minutesRaw).slice(-2);
    var seconds = ("0" + secondsRaw).slice(-2);
    setCountdown(minutes + ":" + seconds);
  }, [setCountdown]);
  var handleSessionCountdownMsgClose = useCallback(function () {
    setIsSessionCountdownMsgOpened(false);
    console.info('Countdown notification hidden!');
  }, []);
  var handleSessionExtendedMsgClose = useCallback(function () {
    return setIsSessionExtendedMsgOpened(false);
  }, []);
  var refreshToken = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setIsTokenRefreshing(true);
            _context.next = 4;
            return refreshJWT({
              userManagementCallObsLogout: userManagementCallObsLogout,
              umtFECallKeycloakLogoutOnSessionTimeout: umtFECallKeycloakLogoutOnSessionTimeout,
              platform: platform
            });
          case 4:
            if (!umtCallOBSLoginEndpointFromFE) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return refreshJSessionId({
              userManagementCallObsLogout: userManagementCallObsLogout,
              umtFECallKeycloakLogoutOnSessionTimeout: umtFECallKeycloakLogoutOnSessionTimeout,
              platform: platform
            });
          case 7:
            // Close the countdown notification
            handleSessionCountdownMsgClose();
            // Open the session extension notification only if the countdown notification was opened
            if (isSessionCountdownMsgOpened) {
              setIsSessionExtendedMsgOpened(true);
            }
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            // Hide session countdown notification:
            handleSessionCountdownMsgClose();
          case 14:
            _context.prev = 14;
            setIsTokenRefreshing(false);
            updateTokenTimes();
            return _context.finish(14);
          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11, 14, 18]]);
  })), [handleSessionCountdownMsgClose, isSessionCountdownMsgOpened, platform, umtFECallKeycloakLogoutOnSessionTimeout, updateTokenTimes, userManagementCallObsLogout, umtCallOBSLoginEndpointFromFE]);
  var handleSessionExtendClick = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return refreshToken();
          case 3:
            console.info('Token has been extended manually!');
            trackSessionEvent(EventAction.SESSION_EXTENDED_MANUALLY);
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  })), [refreshToken, trackSessionEvent]);
  var handleTimeout = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.info('Session has been expired!');
            trackSessionEvent(EventAction.SESSION_EXPIRED);
            handleSessionCountdownMsgClose();
            clearInterval(countdownInterval.current);
            setLoginReferer();
            _context3.next = 7;
            return logOutTheCustomer({
              userManagementCallObsLogout: userManagementCallObsLogout,
              umtFECallKeycloakLogoutOnSessionTimeout: umtFECallKeycloakLogoutOnSessionTimeout,
              platform: platform
            });
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [handleSessionCountdownMsgClose, platform, trackSessionEvent, umtFECallKeycloakLogoutOnSessionTimeout, userManagementCallObsLogout]);
  var shouldShowCountDownMsg = function shouldShowCountDownMsg(isIdleSessionAboutToExpire, isIdleSessionValidationDisabled) {
    return isIdleSessionAboutToExpire && !isIdleSessionValidationDisabled;
  };
  /**
   * Session should expire when:
   * - User is idle for session lifetime
   * - Token expiration time is reached
   *
   * Session should extend when:
   * - User do an activity (click, type, navigate)
   * - User manually extend his session from the session-timeout notification
   */
  var monitorSession = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var isIdleSessionValidationDisabled, timeDiff, expiration, session, issuance, idleDuration, idleDurationRemainingToExpire, tokenDurationRemainingToExpire, expiresIn, isIdleSessionAboutToExpire, isTokenSessionAboutToExpire, isSessionExpired, debugMessage;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            isIdleSessionValidationDisabled = isOnMobileApp();
            timeDiff = tokenTimes.timeDiff, expiration = tokenTimes.expiration, session = tokenTimes.session, issuance = tokenTimes.issuance;
            if (session <= SESSION_EXPIRATION_COUNTDOWN_TIME && umtStopRefreshingTokenWhenAboutToReachMaxSession) {
              setIsSessionExtendable(false);
            }
            idleDuration = Math.max(Math.round(getUnixTime() - lastActiveTime), 0);
            idleDurationRemainingToExpire = Math.max(session - idleDuration, 0);
            tokenDurationRemainingToExpire = Math.max(Math.round(expiration - getUnixTime(-timeDiff)), 0);
            expiresIn = isIdleSessionValidationDisabled ? tokenDurationRemainingToExpire : Math.max(Math.min(idleDurationRemainingToExpire, tokenDurationRemainingToExpire), 0);
            isIdleSessionAboutToExpire = idleDurationRemainingToExpire <= SESSION_EXPIRATION_COUNTDOWN_TIME;
            isTokenSessionAboutToExpire = tokenDurationRemainingToExpire <= SESSION_EXPIRATION_COUNTDOWN_TIME;
            isSessionExpired = expiresIn <= 0;
            debugMessage = "IdleFor: " + idleDuration + " | IdleExpiresIn: " + idleDurationRemainingToExpire + " | TokenIssuedFor: " + Math.round(getUnixTime(-timeDiff) - issuance) + " | TokenExpiresIn: " + tokenDurationRemainingToExpire + " | ExpiresIn: " + expiresIn;
            console.debug(debugMessage);
            if (!isTokenRefreshing) {
              _context4.next = 14;
              break;
            }
            return _context4.abrupt("return");
          case 14:
            if (!isSessionExpired) {
              _context4.next = 18;
              break;
            }
            _context4.next = 17;
            return handleTimeout();
          case 17:
            return _context4.abrupt("return");
          case 18:
            updateCountdown(expiresIn);
            // Show countdown notification if idle session is about to expire
            if (!shouldShowCountDownMsg(isIdleSessionAboutToExpire, isIdleSessionValidationDisabled)) {
              _context4.next = 25;
              break;
            }
            if (isSessionCountdownMsgOpened) {
              _context4.next = 25;
              break;
            }
            setIsSessionCountdownMsgOpened(true);
            console.info('Countdown notification shown!');
            trackSessionEvent(EventAction.SESSION_COUNTDOWN_SHOWN);
            return _context4.abrupt("return");
          case 25:
            if (!(isTokenSessionAboutToExpire && isSessionExtendable)) {
              _context4.next = 36;
              break;
            }
            _context4.prev = 26;
            _context4.next = 29;
            return refreshToken();
          case 29:
            console.info('Token has been extended automatically!');
            trackSessionEvent(EventAction.SESSION_EXTENDED_AUTOMATICALLY, {
              customAttribute1: tokenDurationRemainingToExpire.toString(),
              customAttribute2: isIdleSessionValidationDisabled ? MOBILE_WEBVIEW_IDENTIFIER : undefined
            });
            _context4.next = 36;
            break;
          case 33:
            _context4.prev = 33;
            _context4.t0 = _context4["catch"](26);
            console.error(_context4.t0);
          case 36:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[26, 33]]);
  })), [isSessionCountdownMsgOpened, handleTimeout, isTokenRefreshing, isSessionExtendable, lastActiveTime, refreshToken, tokenTimes, trackSessionEvent, umtStopRefreshingTokenWhenAboutToReachMaxSession, updateCountdown]);
  useEffect(function () {
    if (disabled) return;
    countdownInterval.current = setInterval(monitorSession, 1000);
    return function () {
      return clearInterval(countdownInterval.current);
    };
  }, [disabled, monitorSession]);
  useEffect(function () {
    if (disabled) return;
    initialize();
    var events = ['mouseup', 'keydown', 'touchend'];
    // Updates "lastActiveTime" on a one second throttled interactions/activities
    var handleEvent = throttle(function () {
      setLastActiveTime(getUnixTime());
    }, 1000);
    events.forEach(function (e) {
      document.addEventListener(e, handleEvent);
    });
    return function () {
      events.forEach(function (e) {
        document.removeEventListener(e, handleEvent);
      });
    };
  }, [disabled, initialize, setLastActiveTime]);
  return {
    countdown: countdown,
    isSessionCountdownMsgOpened: isSessionCountdownMsgOpened,
    isSessionExtendedMsgOpened: isSessionExtendedMsgOpened,
    isSessionExtendable: isSessionExtendable,
    handleSessionExtendClick: handleSessionExtendClick,
    handleSessionCountdownMsgClose: handleSessionCountdownMsgClose,
    handleSessionExtendedMsgClose: handleSessionExtendedMsgClose
  };
};

var USE_COUNTDOWN_DEFAULT_VALUE = {
  countdown: '--:--',
  isSessionCountdownMsgOpened: false,
  isSessionExtendedMsgOpened: false,
  isSessionExtendable: false,
  handleSessionExtendClick: function handleSessionExtendClick() {
    return Promise.resolve();
  },
  handleSessionCountdownMsgClose: function handleSessionCountdownMsgClose() {},
  handleSessionExtendedMsgClose: function handleSessionExtendedMsgClose() {}
};
var useCountdown = function useCountdown(_ref) {
  var platform = _ref.platform,
    flags = _ref.flags;
  var _useState = useState(USE_COUNTDOWN_DEFAULT_VALUE),
    countdownProps = _useState[0],
    setCountdownProps = _useState[1];
  /**
   * SessionTimeout feature is disabled only in two cases:
   * - 1: The customer is `NOT` logged-in
   * - 2: The current environment is `localhost` and the `localStorage` has this key `enable_local_session_timeout = true`
   */
  var isSessionTimeoutDisabled = useMemo(function () {
    return !isAuthenticated() || isLocalEnv() && store(LocalStorageKey.ENABLE_LOCAL_SESSION_TIMEOUT) !== true;
  }, []);
  var _useCountdownNew = useCountdownNew({
      platform: platform,
      disabled: isSessionTimeoutDisabled,
      flags: flags
    }),
    countdownNew = _useCountdownNew.countdown,
    isSessionCountdownMsgOpenedNew = _useCountdownNew.isSessionCountdownMsgOpened,
    isSessionExtendedMsgOpenedNew = _useCountdownNew.isSessionExtendedMsgOpened,
    isSessionExtendable = _useCountdownNew.isSessionExtendable,
    handleSessionExtendClickNew = _useCountdownNew.handleSessionExtendClick,
    handleSessionCountdownMsgCloseNew = _useCountdownNew.handleSessionCountdownMsgClose,
    handleSessionExtendedMsgCloseNew = _useCountdownNew.handleSessionExtendedMsgClose;
  useEffect(function () {
    if (isSessionTimeoutDisabled) return;
    setCountdownProps({
      countdown: countdownNew,
      isSessionCountdownMsgOpened: isSessionCountdownMsgOpenedNew,
      isSessionExtendable: isSessionExtendable,
      isSessionExtendedMsgOpened: isSessionExtendedMsgOpenedNew,
      handleSessionExtendClick: handleSessionExtendClickNew,
      handleSessionCountdownMsgClose: handleSessionCountdownMsgCloseNew,
      handleSessionExtendedMsgClose: handleSessionExtendedMsgCloseNew
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionTimeoutDisabled, countdownNew, isSessionCountdownMsgOpenedNew, isSessionExtendable, isSessionExtendedMsgOpenedNew]);
  return countdownProps;
};

/* This hook should be avoided.
 * Screen size can not be resolved on the server side which leads to cumulative layout shift (once its resolved on the client side)
 * JS-based screen size logic should be avoided as much as possible
 * To avoid the CLS where we need to use this hook, we return true during SSR for all screen sizes and hide them accordingly using CSS
 * Once the window object is available, the JS screen size logic will kick in and render only the needed components
 */
function useViewports(theme) {
  var isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  var isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return {
    isDesktop: isDesktop,
    isMobile: isMobile
  };
}

var fontFamily = /*#__PURE__*/['Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',');
// New Font
var fontFamilyV2 = /*#__PURE__*/['Basier Square', 'Verdana', 'sans-serif'].join(',');
var typography = {
  fontFamily: fontFamily,
  fontFamilyV2: fontFamilyV2
};

var MuiButton = {
  defaultProps: {
    disableRipple: true,
    disableElevation: true
  },
  styleOverrides: {
    root: {
      textTransform: 'none'
    }
  }
};

var components = {
  MuiButton: MuiButton
};

/**
 *  It was agreed with PD that we will only support a mobile viewport and a desktop viewport
 *  Mobile viewport is from 0 to 1199
 *  Desktop viewport is from 1200 to ∞
 *  (we do not support tablet viewport due to very low amount of customers that browse our platform on that viewport < 2%)
 *
 *  Furthermore:
 *  PD provides designs for mobile range using 360px screen (actual grid will be 328px wide)
 *  PD provides designs for desktop range using 1440px screen (actual grid is 1272px wide)
 * */
var breakpoints = {
  values: {
    xs: 0,
    sm: 0,
    md: 1024,
    lg: 1024,
    xl: 1024
  }
};

var Colors = {
  white: '#FFFFFF',
  // Blue
  blue100: '#003554',
  blue80: '#004B8C',
  blue60: '#156CC4',
  blue40: '#3A8DFF',
  blue10: '#E8F0F9',
  // Black
  black: '#000000',
  black80: '#404040',
  black70: '#797979',
  black60: '#929292',
  black40: '#D7D7D7',
  black20: '#EEEEEE',
  black10: '#F3F3F3',
  // Error
  error100: '#F44336',
  error10: '#FAE6E4',
  // V2 colors
  blue300: '#62AFFF',
  blue400: '#3096ff',
  blue600: '#1D5A9A',
  grey200: '#C9CED6',
  grey500: '#627187',
  grey900: '#00183C',
  cream100: '#EDEBE9',
  background: '#F7F5F3'
};

var customTheme = {
  typography: typography,
  components: components,
  breakpoints: breakpoints
};
var theme = /*#__PURE__*/createTheme(customTheme);
var theme$1 = /*#__PURE__*/responsiveFontSizes(theme);

var TRANSLATIONS = {
  de: {
    countdown: function countdown(_countdown) {
      return "Sie werden in <strong>" + _countdown + "</strong> abgemeldet.";
    },
    extendSession: 'Sitzung verlängern',
    sessionExtended: function sessionExtended(sessionLifespan) {
      return "Ihre Sitzung wurde erfolgreich um " + sessionLifespan + " Minuten verl\xE4ngert";
    }
  },
  en: {
    countdown: function countdown(_countdown2) {
      return "You will be logged out in <strong>" + _countdown2 + "</strong>.";
    },
    extendSession: 'Extend session',
    sessionExtended: function sessionExtended(sessionLifespan) {
      return "Your session was successfully extended by " + sessionLifespan + " minutes";
    }
  },
  es: {
    countdown: function countdown(_countdown3) {
      return "Tu sesi\xF3n se cerrar\xE1 en <strong>" + _countdown3 + "</strong>.";
    },
    extendSession: 'Continuar sesión',
    sessionExtended: function sessionExtended(sessionLifespan) {
      return "Tu sesi\xF3n se ha extendido " + sessionLifespan + " minutos";
    }
  },
  fr: {
    countdown: function countdown(_countdown4) {
      return "Vous serez d\xE9connect\xE9 dans <strong>" + _countdown4 + "</strong>.";
    },
    extendSession: 'Prolonger la session',
    sessionExtended: function sessionExtended(sessionLifespan) {
      return "Votre session a \xE9t\xE9 prolong\xE9e de " + sessionLifespan + " minutes";
    }
  },
  nl: {
    countdown: function countdown(_countdown5) {
      return "U wordt uitgelogd over <strong>" + _countdown5 + "</strong>.";
    },
    extendSession: 'Sessie verlengen',
    sessionExtended: function sessionExtended(sessionLifespan) {
      return "Uw sessie is verlengd met " + sessionLifespan + " minuten";
    }
  },
  pl: {
    countdown: function countdown(_countdown6) {
      return "Czas pozosta\u0142y do automatycznego wylogowania - <strong>" + _countdown6 + "</strong>.";
    },
    extendSession: 'Przedłuż sesję',
    sessionExtended: function sessionExtended(sessionLifespan) {
      return "Twoja sesja zosta\u0142a przed\u0142u\u017Cona o " + sessionLifespan + " minut";
    }
  },
  fi: {
    countdown: function countdown(_countdown7) {
      return "Sinut kirjataan ulos <strong>" + _countdown7 + "</strong> kuluttua.";
    },
    extendSession: 'Pidennä istuntoa',
    sessionExtended: function sessionExtended(sessionLifespan) {
      return "Istuntoasi pidennettiin " + sessionLifespan + " minuutilla";
    }
  }
};

var SNACKBAR_WIDTH = '320px';
var Snackbar = /*#__PURE__*/styled(Snackbar$1).withConfig({
  displayName: "Snackbar",
  componentId: "uh__sc-1lextsx-0"
})(["@media (max-width:1024px){bottom:16px;}@media (min-width:1024px){top:90px;}user-select:none;& div[role='alert']{box-sizing:border-box;box-shadow:0 1px 5px rgba(0,0,0,0.2),0 3px 1px -2px rgba(0,0,0,0.12),0 2px 2px rgba(0,0,0,0.14);padding:12px 16px;background-color:", ";width:", ";}& .MuiSnackbarContent-message{padding:0;p{font-size:16px;}}& .MuiSnackbarContent-action{margin-right:0;}"], Colors.black80, SNACKBAR_WIDTH);
var SessionExtendedSnackbarContentMessage = /*#__PURE__*/styled('div').withConfig({
  displayName: "SessionExtendedSnackbarContentMessage",
  componentId: "uh__sc-1lextsx-1"
})(["display:flex;align-items:center;gap:10px;"]);
var Button = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "Button",
  componentId: "uh__sc-1lextsx-2"
})(["color:", ";padding:0;margin-top:2px;svg{font-size:24px;}"], Colors.blue40);
var Typography = /*#__PURE__*/styled(Typography$1).withConfig({
  displayName: "Typography",
  componentId: "uh__sc-1lextsx-3"
})(["margin-left:4px;"]);
var IconButton = /*#__PURE__*/styled(IconButton$1).withConfig({
  displayName: "IconButton",
  componentId: "uh__sc-1lextsx-4"
})(["padding:0;svg{font-size:24px;}"]);

var CountdownMessage = function CountdownMessage(_ref) {
  var countdown = _ref.countdown,
    open = _ref.open,
    onClose = _ref.onClose,
    anchorOrigin = _ref.anchorOrigin,
    refreshable = _ref.refreshable,
    onRefresh = _ref.onRefresh;
  var message = useMemo(function () {
    var _TRANSLATIONS$getLoca;
    var translation = (_TRANSLATIONS$getLoca = TRANSLATIONS[getLocale()]) != null ? _TRANSLATIONS$getLoca : TRANSLATIONS.en;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(Typography$1, {
      dangerouslySetInnerHTML: {
        __html: xss(TRANSLATIONS[getLocale()].countdown(countdown))
      }
    }), refreshable && React__default.createElement(Button, {
      "aria-label": "extend-session",
      variant: "text",
      onClick: onRefresh
    }, React__default.createElement(AutorenewIcon, null), React__default.createElement(Typography, null, translation.extendSession)));
  }, [countdown, onRefresh, refreshable]);
  var action = useMemo(function () {
    return React__default.createElement(IconButton, {
      "aria-label": "close",
      color: "inherit",
      onClick: onClose
    }, React__default.createElement(CloseIcon$1, null));
  }, [onClose]);
  return React__default.createElement(Snackbar, {
    open: open,
    onClose: onClose,
    anchorOrigin: anchorOrigin,
    message: message,
    action: action
  });
};

var SessionExtendedMessage = function SessionExtendedMessage(_ref) {
  var open = _ref.open,
    anchorOrigin = _ref.anchorOrigin,
    onClose = _ref.onClose;
  var sessionLifespan = getSessionLifespan();
  var message = useMemo(function () {
    var _TRANSLATIONS$getLoca;
    var translation = (_TRANSLATIONS$getLoca = TRANSLATIONS[getLocale()]) != null ? _TRANSLATIONS$getLoca : TRANSLATIONS.en;
    return React__default.createElement(SessionExtendedSnackbarContentMessage, null, React__default.createElement(CheckIcon, null), React__default.createElement(Typography$1, {
      dangerouslySetInnerHTML: {
        __html: xss(translation.sessionExtended(sessionLifespan))
      }
    }));
  }, [sessionLifespan]);
  return React__default.createElement(Snackbar, {
    open: open,
    autoHideDuration: SESSION_EXTENDED_MESSAGE_AUTO_HIDE_DURATION,
    anchorOrigin: anchorOrigin,
    onClose: onClose,
    message: message
  });
};

var LogoutCountdown = function LogoutCountdown(_ref) {
  var platform = _ref.platform,
    flags = _ref.flags;
  var _useCountdown = useCountdown({
      platform: platform,
      flags: flags
    }),
    countdown = _useCountdown.countdown,
    isSessionCountdownMsgOpened = _useCountdown.isSessionCountdownMsgOpened,
    isSessionExtendedMsgOpened = _useCountdown.isSessionExtendedMsgOpened,
    isSessionExtendable = _useCountdown.isSessionExtendable,
    handleSessionExtendClick = _useCountdown.handleSessionExtendClick,
    handleSessionCountdownMsgClose = _useCountdown.handleSessionCountdownMsgClose,
    handleSessionExtendedMsgClose = _useCountdown.handleSessionExtendedMsgClose;
  var theme = useTheme();
  var _useViewports = useViewports(theme),
    isDesktop = _useViewports.isDesktop;
  var handleCountdownClose = function handleCountdownClose(ـ, reason) {
    if (reason === 'clickaway') return;
    handleSessionCountdownMsgClose();
  };
  var anchorOrigin = isDesktop ? {
    vertical: 'top',
    horizontal: 'right'
  } : {
    vertical: 'bottom',
    horizontal: 'center'
  };
  return React__default.createElement(ThemeProvider, {
    theme: theme$1
  }, React__default.createElement(CountdownMessage, {
    open: isSessionCountdownMsgOpened,
    anchorOrigin: anchorOrigin,
    countdown: countdown,
    onClose: handleCountdownClose,
    refreshable: isSessionExtendable,
    onRefresh: handleSessionExtendClick
  }), React__default.createElement(SessionExtendedMessage, {
    open: isSessionExtendedMsgOpened,
    onClose: handleSessionExtendedMsgClose,
    anchorOrigin: anchorOrigin
  }));
};

var breakpointLG = '1024px';

var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1ytqzgv-0"
})(["display:flex;"]);
var CustomLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1ytqzgv-1"
})(["display:flex;margin:0 16px 0 0;padding:0 16px 0 0;border-right:solid 1px ", ";&:last-child{border-right:0;margin:0;padding:0;}"], Colors.black40);
var CustomImage = /*#__PURE__*/styled.img.withConfig({
  displayName: "CustomImage",
  componentId: "uh__sc-1ytqzgv-2"
})(["max-width:124px;min-width:0;max-height:28px;@media (min-width:", "){max-width:180px;max-height:40px;}"], breakpointLG);

var LogoSection = function LogoSection(_ref) {
  var logoItems = _ref.logoItems;
  return React__default.createElement(Wrapper, null, logoItems.map(function (_ref2) {
    var id = _ref2.id,
      href = _ref2.href,
      url = _ref2.url,
      alt = _ref2.alt;
    return React__default.createElement(CustomLink, {
      key: id,
      href: href
    }, React__default.createElement(CustomImage, {
      src: url,
      alt: alt
    }));
  }));
};

var _excluded = ["className"];
var CustomTooltip = /*#__PURE__*/styled$1(function (_ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React__default.createElement(Tooltip, Object.assign({}, props, {
    classes: {
      popper: className
    },
    slotProps: {
      popper: {
        keepMounted: true,
        disablePortal: true
      }
    }
  }));
})(function () {
  var _ref2;
  return _ref2 = {}, _ref2["." + tooltipClasses.popper + "& ." + tooltipClasses.tooltip] = {
    maxWidth: '762px',
    margin: 0,
    padding: 0,
    display: 'flex',
    backgroundColor: Colors.white,
    color: Colors.black80,
    boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px'
  }, _ref2;
});

var HEADER_TYPE;
(function (HEADER_TYPE) {
  HEADER_TYPE["Public"] = "public";
  HEADER_TYPE["Private"] = "private";
  HEADER_TYPE["Integrated"] = "integrated";
})(HEADER_TYPE || (HEADER_TYPE = {}));
var ACTION_TYPE;
(function (ACTION_TYPE) {
  ACTION_TYPE["Login"] = "login";
  ACTION_TYPE["Registration"] = "registration";
})(ACTION_TYPE || (ACTION_TYPE = {}));
var MENU_LAYOUT;
(function (MENU_LAYOUT) {
  MENU_LAYOUT["Even"] = "even";
  MENU_LAYOUT["Default"] = "default";
})(MENU_LAYOUT || (MENU_LAYOUT = {}));
var MENU_TYPE;
(function (MENU_TYPE) {
  MENU_TYPE["Basic"] = "basic";
  MENU_TYPE["Advanced"] = "advanced";
  MENU_TYPE["Text"] = "text";
  MENU_TYPE["Image"] = "image";
  MENU_TYPE["Arrow"] = "arrow";
})(MENU_TYPE || (MENU_TYPE = {}));

var CloseIcon = function CloseIcon() {
  return React__default.createElement("svg", {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "closeTitle",
    role: "img"
  }, React__default.createElement("title", {
    id: "closeTitle"
  }, "mobile close menu button"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), React__default.createElement("path", {
    fill: "#404040",
    fillRule: "nonzero",
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  })));
};

var OpenIcon = function OpenIcon() {
  return React__default.createElement("svg", {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "openTitle",
    role: "img"
  }, React__default.createElement("title", {
    id: "openTitle"
  }, "mobile open menu button"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), React__default.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
    fill: "#404040",
    fillRule: "nonzero"
  })));
};

var RetirementProvisionIcon = function RetirementProvisionIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M4 22v-9.375L2.2 14 1 12.4l3-2.3V7h2v1.575L12 4l11 8.4-1.2 1.575-1.8-1.35V22H4Zm2-2h5v-4h2v4h5v-8.9l-6-4.575L6 11.1V20ZM4 6c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 7 3a.968.968 0 0 0 .713-.288A.967.967 0 0 0 8 2h2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 7 5a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 6H4Zm2 14h12H6Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var CryptoIcon = function CryptoIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M10.5 3.5v2h3v-2h1v2H17c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06v1.5h-1v-2h-11v11h11v-2h1V17c0 .414-.168.79-.44 1.06-.27.272-.646.44-1.06.44h-2.5v2h-1v-2h-3v2h-1v-2H7c-.414 0-.79-.168-1.06-.44A1.495 1.495 0 0 1 5.5 17V7c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44h2.5v-2h1Z",
    stroke: "#FFF",
    fill: "none",
    fillRule: "evenodd"
  }));
};

var EtfConfiguratorIcon = function EtfConfiguratorIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M11 21v-6h2v2h8v2h-8v2h-2Zm-8-2v-2h6v2H3Zm4-4v-2H3v-2h4V9h2v6H7Zm4-2v-2h10v2H11Zm4-4V3h2v2h4v2h-4v2h-2ZM3 7V5h10v2H3Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var EtfRoboIcon = function EtfRoboIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M8.5 10 7.4 7.6 5 6.5l2.4-1.1L8.5 3l1.1 2.4L12 6.5 9.6 7.6 8.5 10Zm6.5 3-.95-2.05L12 10l2.05-.95L15 7l.95 2.05L18 10l-2.05.95L15 13ZM4 15l-.95-2.05L1 12l2.05-.95L4 9l.95 2.05L7 12l-2.05.95L4 15Zm.5 6.5L3 20l7.5-7.5 4 4 7.1-7.975 1.4 1.4-8.5 9.575-4-4-6 6Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var DepositGuaranteeIcon = function DepositGuaranteeIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M11 17h2v-6h-2v6Zm1-8a.968.968 0 0 0 .713-.288A.967.967 0 0 0 13 8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.967.967 0 0 0-.712.287A.968.968 0 0 0 11 8c0 .283.096.52.288.712A.965.965 0 0 0 12 9Zm0 13c-2.317-.583-4.229-1.913-5.737-3.988C4.754 15.937 4 13.633 4 11.1V5l8-3 8 3v6.1c0 2.533-.754 4.837-2.262 6.912C16.229 20.087 14.317 21.417 12 22Zm0-2.1c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.375l-6-2.25-6 2.25V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var FixedDepositIcon = function FixedDepositIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M8 8h6V6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 11 3c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 8 6v2Zm3.25 14H5c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 3 20V10c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 5 8h1V6c0-1.383.488-2.563 1.463-3.538C8.438 1.487 9.617 1 11 1s2.563.487 3.538 1.462C15.513 3.437 16 4.617 16 6v2h1c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v1.3c-.3-.1-.613-.175-.938-.225A6.995 6.995 0 0 0 17 11v-1H5v10h5.3c.133.4.267.746.4 1.038.133.291.317.612.55.962ZM17 23c-1.383 0-2.562-.487-3.537-1.462C12.488 20.563 12 19.383 12 18s.488-2.563 1.463-3.538C14.438 13.487 15.617 13 17 13s2.563.487 3.538 1.462C21.513 15.437 22 16.617 22 18s-.487 2.563-1.462 3.538C19.563 22.513 18.383 23 17 23Zm1.65-2.65.7-.7-1.85-1.85V15h-1v3.2l2.15 2.15ZM5 10v10-10Z",
    fill: "#FFF",
    fillRule: "evenodd"
  }));
};

var InfoIcon = function InfoIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8997 19.3996C8.5665 19.3996 7.3207 19.1538 6.1623 18.6622C5.0039 18.1706 3.9997 17.4998 3.1497 16.6498C2.2997 15.7998 1.6289 14.7956 1.1373 13.6372C0.645702 12.4788 0.399902 11.233 0.399902 9.89983C0.399902 8.56662 0.645702 7.32502 1.1373 6.17502C1.6289 5.02502 2.2997 4.02082 3.1497 3.16242C3.9997 2.30402 5.0039 1.62902 6.1623 1.13742C7.3207 0.645824 8.5665 0.400024 9.8997 0.400024C11.2329 0.400024 12.4745 0.645824 13.6245 1.13742C14.7745 1.62902 15.7787 2.30402 16.6371 3.16242C17.4955 4.02082 18.1705 5.02502 18.6621 6.17502C19.1537 7.32502 19.3995 8.56662 19.3995 9.89983C19.3995 11.233 19.1537 12.4788 18.6621 13.6372C18.1705 14.7956 17.4955 15.7998 16.6371 16.6498C15.7787 17.4998 14.7745 18.1706 13.6245 18.6622C12.4745 19.1538 11.2329 19.3996 9.8997 19.3996ZM10.4121 7.06242C10.2705 7.20402 10.0997 7.27482 9.8997 7.27482C9.6997 7.27482 9.5289 7.20402 9.3873 7.06242C9.2457 6.92082 9.1749 6.75002 9.1749 6.55002C9.1749 6.35002 9.2457 6.17922 9.3873 6.03762C9.5289 5.89562 9.6997 5.82462 9.8997 5.82462C10.0997 5.82462 10.2705 5.89142 10.4121 6.02502C10.5537 6.15822 10.6245 6.33322 10.6245 6.55002C10.6245 6.75002 10.5537 6.92082 10.4121 7.06242ZM10.5747 14.65H9.2997V8.89962H10.5747V14.65ZM15.7245 15.7246C14.1081 17.3414 12.1665 18.1498 9.8997 18.1498C7.6329 18.1498 5.6913 17.3414 4.0749 15.7246C2.4581 14.1082 1.6497 12.1666 1.6497 9.89983C1.6497 7.63302 2.4581 5.69142 4.0749 4.07502C5.6913 2.45822 7.6329 1.64982 9.8997 1.64982C12.1665 1.64982 14.1081 2.45822 15.7245 4.07502C17.3413 5.69142 18.1497 7.63302 18.1497 9.89983C18.1497 12.1666 17.3413 14.1082 15.7245 15.7246Z",
    fill: "white"
  }));
};

var InvestmentIcon = function InvestmentIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M3.4 18 2 16.6l7.4-7.45 4 4L18.6 8H16V6h6v6h-2V9.4L13.4 16l-4-4z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var TrendingUpIcon = function TrendingUpIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "#FFF",
    fillRule: "nonzero"
  }, createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), createElement("path", {
    d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
  }));
};

var TerminationPaymentIcon = function TerminationPaymentIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M9 3V1h6v2H9Zm2 11h2V8h-2v6Zm1 8a8.655 8.655 0 0 1-3.488-.712A9.202 9.202 0 0 1 5.65 19.35a9.202 9.202 0 0 1-1.938-2.862A8.655 8.655 0 0 1 3 13c0-1.233.237-2.396.712-3.488A9.202 9.202 0 0 1 5.65 6.65a9.188 9.188 0 0 1 2.862-1.937A8.644 8.644 0 0 1 12 4a8.92 8.92 0 0 1 2.975.5c.95.333 1.842.817 2.675 1.45l1.4-1.4 1.4 1.4-1.4 1.4a9.723 9.723 0 0 1 1.45 2.675c.333.95.5 1.942.5 2.975a8.655 8.655 0 0 1-.712 3.488 9.202 9.202 0 0 1-1.938 2.862 9.202 9.202 0 0 1-2.862 1.938A8.655 8.655 0 0 1 12 22Zm0-2c1.933 0 3.583-.683 4.95-2.05C18.317 16.583 19 14.933 19 13c0-1.933-.683-3.583-2.05-4.95C15.583 6.683 13.933 6 12 6c-1.933 0-3.583.683-4.95 2.05C5.683 9.417 5 11.067 5 13c0 1.933.683 3.583 2.05 4.95C8.417 19.317 10.067 20 12 20Z",
    fill: "#FFF",
    fillRule: "evenodd"
  }));
};

var PrivateEquityIcon = function PrivateEquityIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M12 22 2 10l3-6h14l3 6-10 12ZM9.625 9h4.75l-1.5-3h-1.75l-1.5 3ZM11 17.675V11H5.45L11 17.675Zm2 0L18.55 11H13v6.675ZM16.6 9h2.65l-1.5-3H15.1l1.5 3ZM4.75 9H7.4l1.5-3H6.25l-1.5 3Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var EtfRurupIcon = function EtfRurupIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "m19.6 21.025-6.35-6.35 1.4-1.4 6.35 6.35-1.4 1.4Zm-13.65-.7c-1-1-1.742-2.125-2.225-3.375A10.524 10.524 0 0 1 3 13.125c0-1.3.242-2.567.725-3.8.483-1.233 1.225-2.35 2.225-3.35s2.12-1.746 3.362-2.238A10.281 10.281 0 0 1 13.125 3c1.3 0 2.571.246 3.813.737 1.241.492 2.362 1.238 3.362 2.238L5.95 20.325Zm.2-3.05 1.35-1.35c-.267-.35-.52-.708-.762-1.075a15.29 15.29 0 0 1-.663-1.1 10.98 10.98 0 0 1-.525-1.1c-.15-.367-.283-.725-.4-1.075a8.548 8.548 0 0 0-.037 2.95c.158.983.504 1.9 1.037 2.75Zm2.8-2.75 5.55-5.6a11.923 11.923 0 0 0-2.162-1.338c-.725-.341-1.405-.574-2.038-.699-.633-.125-1.204-.146-1.712-.063-.509.083-.905.267-1.188.55-.283.3-.467.704-.55 1.212-.083.509-.062 1.084.063 1.725.125.642.358 1.321.7 2.038.341.717.787 1.442 1.337 2.175Zm6.95-7 1.4-1.35a7.947 7.947 0 0 0-5.75-1c.367.117.733.25 1.1.4.367.15.733.32 1.1.512.367.192.73.409 1.088.65.358.242.712.505 1.062.788Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var SavingIcon = function SavingIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M16 13.5c.433 0 .792-.142 1.075-.425.283-.283.425-.642.425-1.075 0-.433-.142-.792-.425-1.075-.283-.283-.642-.425-1.075-.425-.433 0-.792.142-1.075.425-.283.283-.425.642-.425 1.075 0 .433.142.792.425 1.075.283.283.642.425 1.075.425ZM5 19V5v14Zm0 2c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3 19V5c0-.55.196-1.021.587-1.413A1.928 1.928 0 0 1 5 3h14c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v2.5h-2V5H5v14h14v-2.5h2V19c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 19 21H5Zm8-4c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 11 15V9c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 13 7h7c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v6c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 20 17h-7Zm7-2V9h-7v6h7Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var TaxIcon = function TaxIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M5 18v-7h2v7H5Zm6 0v-7h2v7h-2Zm-9 4v-2h20v2H2Zm15-4v-7h2v7h-2ZM2 9V7l10-5 10 5v2H2Zm4.45-2h11.1-11.1Zm0 0h11.1L12 4.25 6.45 7Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var OvernightMoneyIcon = function OvernightMoneyIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M12 21c-1.25 0-2.42-.237-3.512-.712a9.143 9.143 0 0 1-2.85-1.926 9.143 9.143 0 0 1-1.926-2.85A8.709 8.709 0 0 1 3 12c0-1.25.237-2.421.712-3.513a9.159 9.159 0 0 1 1.926-2.85 9.152 9.152 0 0 1 2.85-1.925A8.709 8.709 0 0 1 12 3c1.367 0 2.663.292 3.888.875A8.733 8.733 0 0 1 19 6.35V4h2v6h-6V8h2.75a7.431 7.431 0 0 0-2.525-2.2A6.75 6.75 0 0 0 12 5c-1.95 0-3.604.679-4.962 2.037C5.679 8.396 5 10.05 5 12c0 1.95.68 3.604 2.038 4.962C8.396 18.321 10.05 19 12 19c1.75 0 3.279-.567 4.587-1.7 1.309-1.133 2.08-2.567 2.313-4.3h2.05c-.25 2.283-1.229 4.187-2.937 5.712C16.304 20.237 14.3 21 12 21Zm2.8-4.8L11 12.4V7h2v4.6l3.2 3.2-1.4 1.4Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var OverviewIcon = function OverviewIcon() {
  return createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M13 11h6.95c-.25-1.833-1.012-3.388-2.287-4.663C16.388 5.062 14.833 4.3 13 4.05V11Zm-2 8.95V4.05c-2.017.25-3.687 1.129-5.012 2.637C4.663 8.196 4 9.967 4 12s.663 3.804 1.988 5.312C7.313 18.821 8.983 19.7 11 19.95Zm2 0c1.833-.233 3.392-.992 4.675-2.275S19.717 14.833 19.95 13H13v6.95ZM12 22a9.732 9.732 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.732 9.732 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2a9.65 9.65 0 0 1 3.887.787 10.178 10.178 0 0 1 3.175 2.151 10.164 10.164 0 0 1 2.15 3.175A9.64 9.64 0 0 1 22 12a9.67 9.67 0 0 1-.788 3.875 10.238 10.238 0 0 1-2.137 3.187 9.983 9.983 0 0 1-3.175 2.15A9.732 9.732 0 0 1 12 22Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

var PagesIcon = function PagesIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, createElement("path", {
    d: "M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z",
    fill: "white"
  }));
};

var PartnerIcon = function PartnerIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "16",
    viewBox: "0 0 22 16",
    fill: "none"
  }, createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30005 7.54999C7.33365 7.54999 6.52965 7.22919 5.88805 6.58759C5.24605 5.94599 4.92505 5.14179 4.92505 4.17499C4.92505 3.20859 5.24605 2.40459 5.88805 1.76299C6.52965 1.12099 7.33365 0.799988 8.30005 0.799988C9.26685 0.799988 10.071 1.12099 10.7126 1.76299C11.3542 2.40459 11.675 3.20859 11.675 4.17499C11.675 5.14179 11.3542 5.94599 10.7126 6.58759C10.071 7.22919 9.26685 7.54999 8.30005 7.54999ZM0.800049 13.175V15.1754H15.8V13.175C15.8 12.6586 15.6626 12.1962 15.3878 11.7878C15.1126 11.3794 14.7418 11.0668 14.2754 10.85C13.2254 10.3836 12.2462 10.0296 11.3378 9.78799C10.4294 9.54599 9.41685 9.42499 8.30005 9.42499C7.18365 9.42499 6.16705 9.54599 5.25025 9.78799C4.33345 10.0296 3.35845 10.3836 2.32525 10.85C1.84205 11.0668 1.46705 11.3794 1.20025 11.7878C0.933449 12.1962 0.800049 12.6586 0.800049 13.175ZM17.75 10.0628C17.0168 9.85439 16.2502 9.68359 15.4502 9.55039C16.0834 9.95039 16.5918 10.4462 16.9754 11.0378C17.3586 11.6294 17.5502 12.3336 17.5502 13.1504V15.1754H21.2504V13.1504C21.2504 12.6668 21.1086 12.2208 20.825 11.8124C20.5418 11.4044 20.1586 11.067 19.6754 10.8002C19.1254 10.517 18.4836 10.2712 17.75 10.0628ZM15.488 6.58759C16.1296 5.94599 16.4504 5.14179 16.4504 4.17499C16.4504 3.20859 16.1296 2.40459 15.488 1.76299C14.846 1.12099 14.0418 0.799988 13.0754 0.799988C12.9418 0.799988 12.8084 0.808388 12.6752 0.825188C12.542 0.841988 12.417 0.866988 12.3002 0.900188C12.6502 1.36699 12.9252 1.86699 13.1252 2.40019C13.3252 2.93339 13.4252 3.52499 13.4252 4.17499C13.4252 4.82499 13.3294 5.42919 13.1378 5.98759C12.9462 6.54599 12.667 7.03359 12.3002 7.45039C12.417 7.48359 12.5462 7.50859 12.6878 7.52539C12.8294 7.54179 12.9586 7.54999 13.0754 7.54999C14.0418 7.54999 14.846 7.22919 15.488 6.58759ZM2.05045 13.925H14.5502V13.175C14.5502 12.925 14.4794 12.696 14.3378 12.488C14.1962 12.2796 13.992 12.1086 13.7252 11.975C12.7584 11.5086 11.8626 11.1754 11.0378 10.9754C10.2126 10.7754 9.30005 10.6754 8.30005 10.6754C7.30005 10.6754 6.38765 10.7754 5.56285 10.9754C4.73765 11.1754 3.83345 11.5086 2.85025 11.975C2.58345 12.1086 2.38345 12.2796 2.25025 12.488C2.11705 12.696 2.05045 12.925 2.05045 13.175V13.925ZM9.81265 5.68759C9.40425 6.09599 8.90005 6.30019 8.30005 6.30019C7.70005 6.30019 7.19605 6.09599 6.78805 5.68759C6.37965 5.27919 6.17545 4.77499 6.17545 4.17499C6.17545 3.57499 6.37965 3.07099 6.78805 2.66299C7.19605 2.25459 7.70005 2.05039 8.30005 2.05039C8.90005 2.05039 9.40425 2.25459 9.81265 2.66299C10.221 3.07099 10.4252 3.57499 10.4252 4.17499C10.4252 4.77499 10.221 5.27919 9.81265 5.68759Z",
    fill: "white"
  }));
};

var PercentIcon = function PercentIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, createElement("path", {
    d: "M6.24992 3.33331C4.64159 3.33331 3.33325 4.64165 3.33325 6.24998C3.33325 7.85831 4.64159 9.16665 6.24992 9.16665C7.85825 9.16665 9.16658 7.85831 9.16658 6.24998C9.16658 4.64165 7.85825 3.33331 6.24992 3.33331ZM6.24992 7.49998C5.55825 7.49998 4.99992 6.94165 4.99992 6.24998C4.99992 5.55831 5.55825 4.99998 6.24992 4.99998C6.94159 4.99998 7.49992 5.55831 7.49992 6.24998C7.49992 6.94165 6.94159 7.49998 6.24992 7.49998ZM13.7499 10.8333C12.1416 10.8333 10.8333 12.1416 10.8333 13.75C10.8333 15.3583 12.1416 16.6666 13.7499 16.6666C15.3583 16.6666 16.6666 15.3583 16.6666 13.75C16.6666 12.1416 15.3583 10.8333 13.7499 10.8333ZM13.7499 15C13.0583 15 12.4999 14.4416 12.4999 13.75C12.4999 13.0583 13.0583 12.5 13.7499 12.5C14.4416 12.5 14.9999 13.0583 14.9999 13.75C14.9999 14.4416 14.4416 15 13.7499 15ZM4.50825 16.6666L3.33325 15.4916L15.4916 3.33331L16.6666 4.50831L4.50825 16.6666Z",
    fill: "white"
  }));
};

var MoneyIcon = function MoneyIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, createElement("path", {
    d: "M13.5064 12.955C12.8076 12.955 12.2163 12.7131 11.7324 12.2293C11.2484 11.7453 11.0064 11.1539 11.0064 10.4553C11.0064 9.75643 11.2484 9.16509 11.7324 8.68126C12.2163 8.19726 12.8076 7.95526 13.5064 7.95526C14.2051 7.95526 14.7964 8.19726 15.2804 8.68126C15.7643 9.16509 16.0062 9.75643 16.0062 10.4553C16.0062 11.1539 15.7643 11.7453 15.2804 12.2293C14.7964 12.7131 14.2051 12.955 13.5064 12.955ZM6.42294 16.2948C5.99611 16.2948 5.62877 16.1408 5.32094 15.833C5.01294 15.525 4.85894 15.1576 4.85894 14.7308V6.17951C4.85894 5.75268 5.01294 5.38526 5.32094 5.07726C5.62877 4.76943 5.99611 4.61551 6.42294 4.61551H20.5897C21.0165 4.61551 21.3839 4.76943 21.6917 5.07726C21.9997 5.38526 22.1537 5.75268 22.1537 6.17951V14.7308C22.1537 15.1576 21.9997 15.525 21.6917 15.833C21.3839 16.1408 21.0165 16.2948 20.5897 16.2948H6.42294ZM8.16669 15.0385H18.8462C18.8462 14.4697 19.0463 13.9856 19.4464 13.5863C19.8464 13.1869 20.3301 12.9873 20.8974 12.9873V7.92301C20.3286 7.92301 19.8445 7.72293 19.4452 7.32276C19.0459 6.92259 18.8462 6.43893 18.8462 5.87176H8.16669C8.16669 6.44059 7.96661 6.92468 7.56644 7.32401C7.16627 7.72334 6.68253 7.92301 6.11519 7.92301V12.9873C6.68403 12.9873 7.16811 13.1873 7.56744 13.5875C7.96694 13.9877 8.16669 14.4713 8.16669 15.0385ZM19.1729 19.3078H3.41019C2.98336 19.3078 2.61602 19.1538 2.30819 18.8458C2.00019 18.5378 1.84619 18.1703 1.84619 17.7435V7.59626H3.10244V17.7435C3.10244 17.8205 3.13452 17.891 3.19869 17.955C3.26286 18.0192 3.33336 18.0513 3.41019 18.0513H19.1729V19.3078ZM6.42294 15.0385H6.11519V5.87176H6.42294C6.33961 5.87176 6.26753 5.90226 6.20669 5.96326C6.14569 6.02409 6.11519 6.09618 6.11519 6.17951V14.7308C6.11519 14.8141 6.14569 14.8863 6.20669 14.9473C6.26753 15.0081 6.33961 15.0385 6.42294 15.0385Z",
    fill: "white"
  }));
};

var CompareIcon = function CompareIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none"
  }, createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.399902 0.799988V15.8H19.3995V0.799988H0.399902ZM3.2499 12.05H4.4997V4.54999H3.2499V12.05ZM6.8499 12.05H9.8997C10.0665 12.05 10.2123 11.9916 10.3371 11.8748C10.4623 11.7584 10.5249 11.6084 10.5249 11.4248V5.17519C10.5249 4.99159 10.4623 4.84159 10.3371 4.72519C10.2123 4.60839 10.0665 4.54999 9.8997 4.54999H6.8499C6.6831 4.54999 6.5373 4.60839 6.4125 4.72519C6.2873 4.84159 6.2247 4.99159 6.2247 5.17519V11.4248C6.2247 11.6084 6.2873 11.7584 6.4125 11.8748C6.5373 11.9916 6.6831 12.05 6.8499 12.05ZM15.9249 12.05H12.7995C12.6331 12.05 12.4873 11.9916 12.3621 11.8748C12.2373 11.7584 12.1749 11.6084 12.1749 11.4248V5.17519C12.1749 4.99159 12.2373 4.84159 12.3621 4.72519C12.4873 4.60839 12.6331 4.54999 12.7995 4.54999H15.9249C16.0913 4.54999 16.2371 4.60839 16.3623 4.72519C16.4871 4.84159 16.5495 4.99159 16.5495 5.17519V11.4248C16.5495 11.6084 16.4871 11.7584 16.3623 11.8748C16.2371 11.9916 16.0913 12.05 15.9249 12.05ZM13.4499 5.79979V10.8002H15.2997V5.79979H13.4499ZM7.4745 5.79979V10.8002H9.2745V5.79979H7.4745ZM18.1497 14.5502H1.6497V2.04979H18.1497V14.5502Z",
    fill: "white"
  }));
};

var ICON_COLLECTION = {
  overnightMoneyIcon: OvernightMoneyIcon,
  overviewIcon: OverviewIcon,
  taxIcon: TaxIcon,
  savingIcon: SavingIcon,
  etfRurupIcon: EtfRurupIcon,
  privateEquityIcon: PrivateEquityIcon,
  terminationPaymentIcon: TerminationPaymentIcon,
  trendingUpIcon: TrendingUpIcon,
  investmentIcon: InvestmentIcon,
  fixedDepositIcon: FixedDepositIcon,
  depositGuaranteeIcon: DepositGuaranteeIcon,
  etfRoboIcon: EtfRoboIcon,
  etfConfiguratorIcon: EtfConfiguratorIcon,
  cryptoIcon: CryptoIcon,
  retirementProvisionIcon: RetirementProvisionIcon,
  pagesIcon: PagesIcon,
  percentIcon: PercentIcon,
  partnerIcon: PartnerIcon,
  moneyIcon: MoneyIcon,
  compareIcon: CompareIcon,
  infoIcon: InfoIcon
};
var getIcon = function getIcon(iconAlias) {
  if (typeof iconAlias === 'undefined' || !ICON_COLLECTION[iconAlias]) {
    return null;
  }
  var IconComponent = ICON_COLLECTION[iconAlias];
  return React__default.createElement(IconComponent, null);
};
var stringAvatar = function stringAvatar(name) {
  if (typeof name === 'undefined') {
    return undefined;
  }
  var nameArray = name.split(' ');
  return "" + nameArray[0][0] + nameArray.slice(-1)[0][0];
};
var copyHandler = function copyHandler(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  }
};
var isActiveMenu = function isActiveMenu(href) {
  if (href === void 0) {
    href = '';
  }
  if (isCSR()) {
    var pathname = window.location.pathname;
    var hash = window.location.hash;
    return ("" + pathname + hash).toLowerCase() === href.toLowerCase();
  }
  return false;
};
var getActiveStatus = function getActiveStatus(subMenus, href) {
  if (!subMenus) return isActiveMenu(href);
  var items = Object.values(subMenus).reduce(function (accumulator, currentValue) {
    return [].concat(accumulator, Array.isArray(currentValue) ? currentValue : []);
  }, []);
  return items.some(function (item) {
    return isActiveMenu(item == null ? void 0 : item.href);
  });
};
var isHrefCorrect = function isHrefCorrect(href) {
  if (href === void 0) {
    href = '';
  }
  return !isEmpty(href) && href.indexOf('javascript:void(0)') < 0;
};
var isTablet = function isTablet() {
  if (!isCSR()) {
    return false;
  }
  return navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
};

var fontRegularCommon = /*#__PURE__*/css(["font-family:", ";font-style:normal;font-weight:normal;"], typography.fontFamily);
var fontRegular14 = /*#__PURE__*/css(["", " font-size:14px;line-height:18px;"], fontRegularCommon);
var fontRegular16 = /*#__PURE__*/css(["", " font-size:16px;line-height:24px;"], fontRegularCommon);
var fontRegular24 = /*#__PURE__*/css(["", " font-size:24px;line-height:32px;"], fontRegularCommon);
var fontSemiboldCommon = /*#__PURE__*/css(["font-family:", ";font-style:normal;font-weight:600;"], typography.fontFamily);
var fontSemibold14 = /*#__PURE__*/css(["", " font-size:14px;line-height:18px;"], fontSemiboldCommon);
var fontSemibold16 = /*#__PURE__*/css(["", " font-size:16px;line-height:24px;"], fontSemiboldCommon);
var fontSemibold20 = /*#__PURE__*/css(["", " font-size:20px;line-height:28px;"], fontSemiboldCommon);

var StyledLink = /*#__PURE__*/withTheme( /*#__PURE__*/styled(Link).withConfig({
  displayName: "StyledLink",
  componentId: "uh__sc-12gmq1q-0"
})(["&.MuiLink-root{color:", ";text-decoration:none;font-weight:600;&:hover{color:", ";background-color:", ";text-decoration:none;cursor:pointer;}&:focus,&:active{color:", ";text-decoration:none;}}"], function (props) {
  return props.$isActive ? Colors.blue60 : Colors.black80;
}, function (props) {
  return props.$isActive ? Colors.blue60 : Colors.black80;
}, Colors.black10, Colors.blue60));
var GroupName = /*#__PURE__*/styled.header.withConfig({
  displayName: "GroupName",
  componentId: "uh__sc-12gmq1q-1"
})(["margin-bottom:8px;padding:0 16px;display:none;", " color:", ";&:first-child{display:block;}"], fontSemibold20, Colors.black80);

var CustomLink$1 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1o2gitz-0"
})(["display:flex;"]);
var Wrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1o2gitz-1"
})(["padding:16px;display:flex;align-items:center;.iconWrapper{margin-right:16px;.MuiAvatar-root{font-size:22px;}}.mainWrapper{display:flex;flex-direction:column;}.title{display:flex;align-items:center;", "}.description{", "}"], fontSemibold16, fontRegular14);
var Tag = /*#__PURE__*/styled.span.withConfig({
  displayName: "Tag",
  componentId: "uh__sc-1o2gitz-2"
})(["margin-left:4px;padding:0 6px;", " color:", ";background-color:", ";border-radius:2px;"], fontSemibold14, Colors.blue60, Colors.blue10);

var AdvancedSubMenu = function AdvancedSubMenu(_ref) {
  var item = _ref.item;
  var href = item.href,
    title = item.title,
    description = item.description,
    icon = item.icon,
    iconColor = item.iconColor,
    tag = item.tag,
    groupName = item.groupName;
  var IconComponent = getIcon(icon);
  return React__default.createElement(React__default.Fragment, null, groupName ? React__default.createElement(GroupName, null, groupName) : null, React__default.createElement(CustomLink$1, {
    href: href,
    underline: "none",
    "$isActive": isActiveMenu(href)
  }, React__default.createElement(Wrapper$1, null, React__default.createElement("div", {
    className: "iconWrapper"
  }, IconComponent ? React__default.createElement(Avatar, {
    sx: {
      bgcolor: iconColor,
      width: 46,
      height: 46
    }
  }, IconComponent) : React__default.createElement(Avatar, {
    sx: {
      width: 46,
      height: 46
    },
    src: icon
  })), React__default.createElement("div", {
    className: "mainWrapper"
  }, React__default.createElement("span", {
    className: "title"
  }, title, !tag ? null : React__default.createElement(Tag, null, tag)), React__default.createElement("span", {
    className: "description"
  }, description)))));
};

var CustomLink$2 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-pwo70f-0"
})(["min-width:340px;width:100%;box-sizing:border-box;flex:0 0 auto;display:flex;"]);
var Wrapper$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-pwo70f-1"
})(["flex:1;padding:16px;display:flex;align-items:center;.iconWrapper{margin-right:16px;.MuiAvatar-root{font-size:22px;}}.mainWrapper{display:flex;flex-direction:column;}.title{display:flex;align-items:center;", "}"], fontSemibold16);

var BasicSubMenu = function BasicSubMenu(_ref) {
  var item = _ref.item;
  var href = item.href,
    title = item.title,
    icon = item.icon,
    iconColor = item.iconColor,
    groupName = item.groupName;
  var IconComponent = getIcon(icon);
  return React__default.createElement(React__default.Fragment, null, groupName ? React__default.createElement(GroupName, null, groupName) : null, React__default.createElement(CustomLink$2, {
    href: href,
    underline: "none",
    "$isActive": isActiveMenu(href)
  }, React__default.createElement(Wrapper$2, null, React__default.createElement("div", {
    className: "iconWrapper"
  }, React__default.createElement(Avatar, {
    sx: {
      bgcolor: iconColor,
      width: 46,
      height: 46
    }
  }, IconComponent)), React__default.createElement("div", {
    className: "mainWrapper"
  }, React__default.createElement("span", {
    className: "title"
  }, title)))));
};

var CustomLink$3 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1fa7rsp-0"
})(["width:fit-content;margin:0 auto 16px;border-radius:4px;display:flex;border-radius:4px;justify-content:center;&.MuiLink-root{color:", ";background-color:", ";&:hover,&:focus,&:active{color:", ";background-color:", ";}}"], Colors.black80, function (props) {
  return props.$isActive ? Colors.blue10 : Colors.white;
}, Colors.blue60, Colors.blue10);
var Wrapper$3 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1fa7rsp-1"
})(["padding:8px;display:flex;flex-direction:column;align-items:center;.mainWrapper{display:flex;flex-direction:column;}.menuImage{max-width:167px;border-radius:2px;}.title{max-width:167px;", "}"], fontSemibold16);

var ImageSubMenu = function ImageSubMenu(_ref) {
  var item = _ref.item;
  var href = item.href,
    title = item.title,
    imageUrl = item.imageUrl,
    description = item.description;
  return React__default.createElement(CustomLink$3, {
    href: href,
    underline: "none",
    "$isActive": isActiveMenu(href)
  }, React__default.createElement(Wrapper$3, null, React__default.createElement("img", {
    className: "menuImage",
    src: imageUrl,
    alt: description
  }), React__default.createElement("div", {
    className: "mainWrapper"
  }, React__default.createElement("span", {
    className: "title"
  }, title))));
};

var CustomLink$4 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-iq8aah-0"
})(["&.MuiLink-root{margin:0 0 4px;display:flex;border-radius:4px;&:last-child{margin:0;}&:hover,&:focus,&:active{color:", ";background-color:", ";}}"], Colors.blue60, Colors.white);
var Wrapper$4 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-iq8aah-1"
})(["padding:0;display:flex;.MuiSvgIcon-root{font-size:24px;}.title{", "}"], fontSemibold16);

var ArrowSubMenu = function ArrowSubMenu(_ref) {
  var item = _ref.item;
  var href = item.href,
    title = item.title;
  return React__default.createElement(CustomLink$4, {
    href: href,
    underline: "none",
    "$isActive": isActiveMenu(href)
  }, React__default.createElement(Wrapper$4, null, React__default.createElement(ChevronRightIcon, null), React__default.createElement("span", {
    className: "title"
  }, title)));
};

var CustomLink$5 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-2skwdl-0"
})(["display:flex;&:last-child{margin:0;}"]);
var Wrapper$5 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-2skwdl-1"
})(["padding:16px;display:flex;align-items:center;.title{", "}@media (min-width:", "){padding:16px 24px;}"], fontSemibold16, breakpointLG);

var TextSubMenu = function TextSubMenu(_ref) {
  var item = _ref.item;
  var href = item.href,
    title = item.title,
    callback = item.callback;
  var mainHref = isEmpty(href) ? undefined : href;
  return React__default.createElement(CustomLink$5, {
    href: mainHref,
    underline: "none",
    "$isActive": isActiveMenu(href),
    onClick: callback ? callback : undefined
  }, React__default.createElement(Wrapper$5, null, React__default.createElement("span", {
    className: "title"
  }, title)));
};

var _MENU_COLLECTION;
var MENU_COLLECTION = (_MENU_COLLECTION = {}, _MENU_COLLECTION[MENU_TYPE.Advanced] = AdvancedSubMenu, _MENU_COLLECTION[MENU_TYPE.Basic] = BasicSubMenu, _MENU_COLLECTION[MENU_TYPE.Text] = TextSubMenu, _MENU_COLLECTION[MENU_TYPE.Image] = ImageSubMenu, _MENU_COLLECTION[MENU_TYPE.Arrow] = ArrowSubMenu, _MENU_COLLECTION);
var getSubMenu = function getSubMenu(type, item) {
  if (!MENU_COLLECTION[type]) {
    return null;
  }
  var MenuComponent = MENU_COLLECTION[type];
  return React__default.createElement(MenuComponent, {
    item: item
  });
};

var SubMenuSection = function SubMenuSection(_ref) {
  var items = _ref.items;
  if (typeof items === 'undefined') {
    return null;
  }
  return React__default.createElement(React__default.Fragment, null, items.map(function (item) {
    return item ? React__default.createElement(Fragment, {
      key: item.id
    }, getSubMenu(item.type, item)) : null;
  }));
};

var desktopStyles = /*#__PURE__*/css(["min-width:", ";max-width:", ";flex:1;display:flex;flex-direction:column;.top{flex:1;padding:8px 0;display:flex;box-sizing:border-box;}.middle{display:flex;box-sizing:border-box;}.main{flex:", ";padding:16px 0;box-sizing:border-box;display:flex;flex-direction:column;border-top:solid 1px ", ";}.sidebar{max-width:", ";min-width:", ";box-sizing:border-box;flex:", ";padding:", ";border-top:solid 1px ", ";border-left:solid 1px ", ";}.bottom{flex:1;padding:16px;box-sizing:border-box;border-top:solid 1px ", ";}"], function (props) {
  return props.$layout === MENU_LAYOUT.Even ? '340px' : 'auto';
}, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? 'auto' : '580px';
}, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? '1' : '0 1 auto';
}, Colors.black40, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? 'auto' : '200px';
}, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? 'auto' : '200px';
}, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? '1' : '0 0 200px;';
}, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? '16px 0' : '16px 8px';
}, Colors.black40, Colors.black40, Colors.black40);
var mobileStyles = /*#__PURE__*/css(["min-width:", ";width:100%;flex:1;display:flex;flex-direction:column;.top{padding:0;box-sizing:border-box;}.main{flex:1;padding:4px 0;box-sizing:border-box;display:flex;flex-direction:column;}.sidebar{display:", ";flex-direction:column;box-sizing:border-box;flex:1;padding:", ";border-left:solid 1px ", ";}.bottom{display:", ";padding:0 8px;box-sizing:border-box;&:before{content:'';display:flex;margin:8px;border-bottom:solid 1px ", ";}}"], function (props) {
  return props.$layout === MENU_LAYOUT.Even ? '340px' : 'auto';
}, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? 'flex' : 'none';
}, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? '16px 0' : '16px 8px';
}, Colors.black40, function (props) {
  return props.$layout === MENU_LAYOUT.Even ? 'flex' : 'none';
}, Colors.black40);
var Wrapper$6 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1nevzf6-0"
})(["", ";"], function (props) {
  return props.$isMobile === true ? mobileStyles : desktopStyles;
});

var SubMenuContainer = function SubMenuContainer(_ref) {
  var subMenus = _ref.subMenus,
    clickCallback = _ref.clickCallback;
  var theme = useTheme();
  var _useViewports = useViewports(theme),
    isMobile = _useViewports.isMobile;
  if (typeof subMenus === 'undefined') {
    return null;
  }
  var top = subMenus.top,
    main = subMenus.main,
    sidebar = subMenus.sidebar,
    bottom = subMenus.bottom,
    _subMenus$layout = subMenus.layout,
    layout = _subMenus$layout === void 0 ? MENU_LAYOUT.Default : _subMenus$layout;
  return React__default.createElement(Wrapper$6, {
    "$layout": layout,
    "$isMobile": isMobile,
    onClick: clickCallback
  }, !isEmpty(compact(top)) ? React__default.createElement("div", {
    className: "top"
  }, React__default.createElement(SubMenuSection, {
    items: top
  })) : null, React__default.createElement("div", {
    className: "middle"
  }, !isEmpty(compact(main)) ? React__default.createElement("div", {
    className: "main"
  }, React__default.createElement(SubMenuSection, {
    items: main
  })) : null, !isEmpty(compact(sidebar)) ? React__default.createElement("div", {
    className: "sidebar"
  }, React__default.createElement(SubMenuSection, {
    items: sidebar
  })) : null), !isEmpty(compact(bottom)) ? React__default.createElement("div", {
    className: "bottom"
  }, React__default.createElement(SubMenuSection, {
    items: bottom
  })) : null);
};

var _excluded$1 = ["className"];
var CopiedTooltip = /*#__PURE__*/styled$1(function (_ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return React__default.createElement(Tooltip, Object.assign({}, props, {
    classes: {
      popper: className
    }
  }));
})(function () {
  var _ref2;
  return _ref2 = {}, _ref2["." + tooltipClasses.popper + "& ." + tooltipClasses.tooltip + " .MuiSvgIcon-root"] = {
    fontSize: '24px'
  }, _ref2;
});

var Wrapper$7 = /*#__PURE__*/styled.section.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-lhm6e5-0"
})(["display:flex;align-items:center;"]);
var AvatarName = /*#__PURE__*/styled(Avatar).withConfig({
  displayName: "AvatarName",
  componentId: "uh__sc-lhm6e5-1"
})(["&.MuiAvatar-root{margin-right:8px;", " color:", ";background-color:", ";}"], fontRegular16, Colors.blue60, Colors.blue10);
var FullName = /*#__PURE__*/styled.div.withConfig({
  displayName: "FullName",
  componentId: "uh__sc-lhm6e5-2"
})(["", " color:", ";"], fontSemibold16, Colors.black80);
var Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "uh__sc-lhm6e5-3"
})(["flex:1;"]);
var AccountWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccountWrapper",
  componentId: "uh__sc-lhm6e5-4"
})(["display:flex;justify-content:space-between;align-items:center;"]);
var AccountLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccountLabel",
  componentId: "uh__sc-lhm6e5-5"
})(["", " color:", ";"], fontRegular16, Colors.black80);
var AccountId = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccountId",
  componentId: "uh__sc-lhm6e5-6"
})(["display:flex;align-items:center;", " color:", ";"], fontRegular16, Colors.black80);
var CopyIcon = /*#__PURE__*/styled(FileCopyOutlinedIcon).withConfig({
  displayName: "CopyIcon",
  componentId: "uh__sc-lhm6e5-7"
})(["margin-left:8px;font-size:24px;width:", ";cursor:pointer;"], function (props) {
  return props.$size === 'default' ? '22px' : '16px';
});

var AUTO_HIDE_DURATION = 3000;
var UserSection = function UserSection(_ref) {
  var displayName = _ref.displayName,
    fullName = _ref.fullName,
    accountIds = _ref.accountIds,
    isDropdownOpen = _ref.isDropdownOpen;
  var theme = useTheme();
  var _useViewports = useViewports(theme),
    isMobile = _useViewports.isMobile;
  var _useState = useState(),
    openedId = _useState[0],
    setOpenedId = _useState[1];
  var clickHandler = function clickHandler(id) {
    copyHandler(IBAN.isValid(id) ? IBAN.electronicFormat(id) : id);
    setOpenedId(id);
  };
  useEffect(function () {
    var timer;
    if (openedId) {
      timer = setTimeout(function () {
        setOpenedId(undefined);
      }, AUTO_HIDE_DURATION);
    }
    return function () {
      clearTimeout(timer);
    };
  }, [openedId]);
  useEffect(function () {
    if (!isDropdownOpen) {
      setOpenedId(undefined);
    }
  }, [isDropdownOpen]);
  return React__default.createElement(Wrapper$7, null, React__default.createElement("div", null, React__default.createElement(AvatarName, null, stringAvatar(displayName))), React__default.createElement(Container, null, React__default.createElement(FullName, null, fullName), accountIds.map(function (_ref2) {
    var id = _ref2.id,
      label = _ref2.label,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'default' : _ref2$size;
    return React__default.createElement(AccountWrapper, {
      key: id
    }, label ? React__default.createElement(AccountLabel, null, label) : null, id ? React__default.createElement(AccountId, null, IBAN.isValid(id) ? IBAN.printFormat(id, ' ') : id, React__default.createElement(CopiedTooltip, {
      title: React__default.createElement(CheckCircleOutlineIcon, null),
      placement: "top",
      open: isMobile ? openedId === id : openedId === id && isDropdownOpen,
      arrow: true
    }, React__default.createElement(CopyIcon, {
      "$size": size,
      onClick: function onClick() {
        return clickHandler(id);
      }
    }))) : null);
  })));
};

var Wrapper$8 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-3ow0g1-0"
})(["min-width:360px;flex:1;display:flex;flex-direction:column;"]);
var InfoSection = /*#__PURE__*/styled.section.withConfig({
  displayName: "InfoSection",
  componentId: "uh__sc-3ow0g1-1"
})(["flex:1;padding:16px 24px;box-sizing:border-box;display:flex;flex-direction:column;border-top:solid 1px ", ";"], Colors.black40);
var MenuSection = /*#__PURE__*/styled.section.withConfig({
  displayName: "MenuSection",
  componentId: "uh__sc-3ow0g1-2"
})(["flex:1;padding:4px 0;box-sizing:border-box;display:flex;flex-direction:column;border-top:solid 1px ", ";"], Colors.black40);

var CustomerMenuContainer = function CustomerMenuContainer(_ref) {
  var isDropdownOpen = _ref.isDropdownOpen,
    customer = _ref.customer;
  if (typeof customer === 'undefined') {
    return null;
  }
  var displayName = customer.displayName,
    fullName = customer.fullName,
    accountIds = customer.accountIds,
    subMenus = customer.subMenus,
    actionItems = customer.actionItems;
  return React__default.createElement(Wrapper$8, null, React__default.createElement(InfoSection, null, React__default.createElement(UserSection, {
    isDropdownOpen: isDropdownOpen,
    displayName: displayName,
    fullName: fullName,
    accountIds: accountIds
  })), subMenus ? React__default.createElement(MenuSection, null, subMenus.map(function (item) {
    return item ? React__default.createElement(Fragment, {
      key: item.id
    }, getSubMenu(item.type, item)) : null;
  })) : null, React__default.createElement(MenuSection, null, actionItems.map(function (item) {
    return React__default.createElement(Fragment, {
      key: item.id
    }, getSubMenu(item.type, item));
  })));
};

var CUSTOMER_PRIVATE_MENU = 'customerPrivateMenu';
var DEFAULT_PROPS = {
  TransitionComponent: Fade,
  disableFocusListener: true,
  placement: 'bottom-start'
};
var LAPTOP_PROPS = {
  enterDelay: 50
};
var TABLET_PROPS = {
  disableHoverListener: true,
  disableTouchListener: true
};

var bgcolor = '#ebebeb';
var Skeleton = function Skeleton(props) {
  return React__default.createElement(Skeleton$2, Object.assign({
    "aria-label": "skeleton-loader"
  }, props, {
    sx: {
      bgcolor: bgcolor
    },
    animation: "wave"
  }));
};

var CustomNav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "CustomNav",
  componentId: "uh__sc-1mazaud-0"
})(["display:none;margin-left:64px;@media (min-width:", "){display:", ";}"], breakpointLG, function (props) {
  return props.$type === HEADER_TYPE.Integrated ? 'none' : 'block';
});
var CustomList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "CustomList",
  componentId: "uh__sc-1mazaud-1"
})(["margin:0;padding:0;display:flex;align-items:center;list-style-type:none;"]);
var CustomListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "CustomListItem",
  componentId: "uh__sc-1mazaud-2"
})(["margin-right:8px;display:flex;align-items:center;&:last-of-type{margin-right:0;}.avatarButton{&:hover{background-color:transparent;}}.avatarName{", " color:", ";background-color:", ";}.avatarIcon{margin-left:8px;transform:rotate(-90deg);color:", ";}"], fontRegular16, Colors.blue60, Colors.blue10, Colors.black80);
var CustomLink$6 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1mazaud-3"
})(["padding:8px 16px;", " border-radius:4px;"], fontSemibold16);
var CustomBadge = /*#__PURE__*/styled(Badge).withConfig({
  displayName: "CustomBadge",
  componentId: "uh__sc-1mazaud-4"
})([".MuiBadge-badge{right:-8px;}"]);
var CustomBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CustomBox",
  componentId: "uh__sc-1mazaud-5"
})(["display:flex;align-items:center;column-gap:16px;"]);

var PrivateLoader = function PrivateLoader(_ref) {
  var _ref$skeletonColumns = _ref.skeletonColumns,
    skeletonColumns = _ref$skeletonColumns === void 0 ? 4 : _ref$skeletonColumns;
  var columns = new Array(skeletonColumns).fill(null);
  return React__default.createElement(CustomBox, {
    "aria-label": "loading",
    role: "presentation"
  }, columns.map(function (_, index) {
    return React__default.createElement(Skeleton, {
      key: index,
      variant: "rounded",
      width: 110,
      height: 24
    });
  }), React__default.createElement(Skeleton, {
    variant: "circular"
  }, React__default.createElement(Avatar, null)));
};

var Navigation = function Navigation(_ref) {
  var type = _ref.type,
    navItems = _ref.navItems,
    customer = _ref.customer,
    shouldShowPrivateLoader = _ref.shouldShowPrivateLoader;
  var _useState = useState(),
    openedId = _useState[0],
    setOpenedId = _useState[1];
  var handleClose = function handleClose() {
    setOpenedId(undefined);
  };
  var handleOpen = function handleOpen(id) {
    setOpenedId(id);
  };
  var MainNavProps = _extends({}, DEFAULT_PROPS, isTablet() ? TABLET_PROPS : LAPTOP_PROPS);
  if (shouldShowPrivateLoader) {
    return React__default.createElement(CustomNav, {
      "$type": type
    }, React__default.createElement(PrivateLoader, null));
  }
  return React__default.createElement(CustomNav, {
    "$type": type
  }, React__default.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, React__default.createElement(CustomList, null, navItems.map(function (_ref2) {
    var id = _ref2.id,
      href = _ref2.href,
      title = _ref2.title,
      subMenus = _ref2.subMenus,
      _ref2$enableBadge = _ref2.enableBadge,
      enableBadge = _ref2$enableBadge === void 0 ? false : _ref2$enableBadge;
    var showBadge = enableBadge === true && (customer == null ? void 0 : customer.showUnreadMessage) === true;
    var isActive = getActiveStatus(subMenus, href);
    var mainHref = isEmpty(href) ? undefined : href;
    return React__default.createElement(CustomTooltip, Object.assign({}, MainNavProps, {
      title: React__default.createElement(SubMenuContainer, {
        subMenus: subMenus,
        clickCallback: handleClose
      }),
      key: id,
      open: openedId === id,
      onClose: handleClose,
      onOpen: function onOpen() {
        return handleOpen(id);
      }
    }), React__default.createElement(CustomListItem, null, React__default.createElement(CustomLink$6, {
      href: mainHref,
      underline: "none",
      "$isActive": isActive,
      onClick: function onClick() {
        return handleOpen(id);
      }
    }, React__default.createElement(CustomBadge, {
      variant: "dot",
      invisible: !showBadge,
      color: "error"
    }, title))));
  }), type === HEADER_TYPE.Private ? React__default.createElement(CustomTooltip, Object.assign({}, MainNavProps, {
    title: React__default.createElement(CustomerMenuContainer, {
      isDropdownOpen: openedId === CUSTOMER_PRIVATE_MENU,
      customer: customer
    }),
    key: CUSTOMER_PRIVATE_MENU,
    open: openedId === CUSTOMER_PRIVATE_MENU,
    onClose: handleClose,
    onOpen: function onOpen() {
      return handleOpen(CUSTOMER_PRIVATE_MENU);
    }
  }), React__default.createElement(CustomListItem, null, React__default.createElement(Button$2, {
    className: "avatarButton",
    disableRipple: true,
    onClick: function onClick() {
      return handleOpen(CUSTOMER_PRIVATE_MENU);
    }
  }, React__default.createElement(Avatar, {
    className: "avatarName"
  }, stringAvatar(customer == null ? void 0 : customer.displayName)), React__default.createElement(ChevronLeftIcon, {
    className: "avatarIcon"
  })))) : null)));
};

var Wrapper$9 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-u3txd9-0"
})(["display:none;@media (min-width:", "){display:flex;align-items:center;}"], breakpointLG);
var CustomLink$7 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-u3txd9-1"
})(["&.MuiLink-root{padding:8px 16px;", " border-radius:4px;color:", ";&:hover,&:focus,&:active{color:", ";}}"], fontSemibold16, Colors.black80, Colors.black80);
var RegistrationLink = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "RegistrationLink",
  componentId: "uh__sc-u3txd9-2"
})(["&.MuiLink-root{margin-left:8px;padding:8px 16px;", " border-radius:4px;color:", ";background-color:", ";&:hover,&:focus,&:active{color:", ";background-color:", ";}}"], fontSemibold16, Colors.white, Colors.blue60, Colors.white, Colors.blue80);

var ActionsSection = function ActionsSection(_ref) {
  var actionItems = _ref.actionItems;
  return React__default.createElement(Wrapper$9, null, actionItems.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      href = _ref2.href,
      type = _ref2.type;
    return React__default.createElement(Fragment, {
      key: id
    }, type === 'login' ? React__default.createElement(CustomLink$7, {
      href: href,
      underline: "none"
    }, title) : React__default.createElement(RegistrationLink, {
      href: href,
      underline: "none"
    }, title));
  }));
};

var MobilePrivateLoader = function MobilePrivateLoader() {
  return React__default.createElement(Box$1, {
    "aria-label": "mobile loading",
    role: "presentation"
  }, React__default.createElement(Skeleton, {
    variant: "rounded",
    width: 24,
    height: 24
  }));
};

var Wrapper$a = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-dab01a-0"
})(["display:flex;@media (min-width:", "){display:none;}.iconButton{margin-right:-8px;}"], breakpointLG);

var HamburgerSection = function HamburgerSection(_ref) {
  var mobilePanelDisplay = _ref.mobilePanelDisplay,
    setMobilePanelDisplay = _ref.setMobilePanelDisplay,
    shouldShowPrivateLoader = _ref.shouldShowPrivateLoader;
  var toggleMobilePanelHandler = function toggleMobilePanelHandler() {
    setMobilePanelDisplay(!mobilePanelDisplay);
  };
  if (shouldShowPrivateLoader) {
    return React__default.createElement(Wrapper$a, null, React__default.createElement(MobilePrivateLoader, null));
  }
  return React__default.createElement(Wrapper$a, null, React__default.createElement(IconButton$2, {
    className: "iconButton",
    onClick: toggleMobilePanelHandler,
    role: "button"
  }, mobilePanelDisplay ? React__default.createElement(CloseIcon, null) : React__default.createElement(OpenIcon, null)));
};

var Wrapper$b = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1evf15l-0"
})(["width:100vw;height:calc(100vh - 64px);box-sizing:border-box;display:", ";flex-direction:column;top:64px;left:0;position:absolute;z-index:10;background-color:", ";overflow-y:auto;@media (min-width:", "){display:none;}"], function (props) {
  return props.$open === true ? 'flex' : 'none';
}, Colors.white, breakpointLG);

var MobilePanelContainer = function MobilePanelContainer(_ref) {
  var mobilePanelDisplay = _ref.mobilePanelDisplay,
    children = _ref.children;
  useEffect(function () {
    if (typeof document !== 'undefined' && mobilePanelDisplay === true) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
    } else {
      document.body.style.overflow = '';
      document.body.style.height = '';
    }
  }, [mobilePanelDisplay]);
  return React__default.createElement(React__default.Fragment, null, mobilePanelDisplay ? React__default.createElement(Wrapper$b, {
    "$open": mobilePanelDisplay
  }, children) : null);
};

var StyledMuiAccordion = /*#__PURE__*/styled(MuiAccordion).withConfig({
  displayName: "StyledMuiAccordion",
  componentId: "uh__sc-1bp2r8h-0"
})(["width:100%;border:0;&:not(:last-child){border-bottom:0;}&:before{display:none;}"]);
var StyledAccordionSummary = /*#__PURE__*/styled(MuiAccordionSummary).withConfig({
  displayName: "StyledAccordionSummary",
  componentId: "uh__sc-1bp2r8h-1"
})(["padding:12px 16px;.MuiAccordionSummary-expandIconWrapper{color:", ";.MuiSvgIcon-root{font-size:24px;}}.MuiAccordionSummary-expandIconWrapper.Mui-expanded{transform:rotate(180deg);}.MuiAccordionSummary-content{margin:0;}"], Colors.black80);
var StyledAccordionDetails = /*#__PURE__*/styled(MuiAccordionDetails).withConfig({
  displayName: "StyledAccordionDetails",
  componentId: "uh__sc-1bp2r8h-2"
})(["padding:0;"]);

var CustomAccordion = function CustomAccordion(props) {
  return createElement(StyledMuiAccordion, Object.assign({
    disableGutters: true,
    elevation: 0,
    square: true
  }, props));
};
var CustomAccordionSummary = function CustomAccordionSummary(props) {
  var href = props.href;
  return createElement(StyledAccordionSummary, Object.assign({
    expandIcon: isHrefCorrect(href) ? null : createElement(KeyboardArrowDownIcon, null)
  }, props));
};
var CustomAccordionDetails = StyledAccordionDetails;

var basicLinkStyle = /*#__PURE__*/css(["flex:1;text-align:center;padding:8px 16px;", " border-radius:4px;"], fontSemibold16);
var Wrapper$c = /*#__PURE__*/styled.section.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1oityht-0"
})(["width:100%;height:70px;position:fixed;padding:0 16px;box-sizing:border-box;", " left:0;display:flex;justify-content:center;align-items:center;background-color:", ";border-top:", ";border-bottom:", ";@media (min-width:", "){display:none;}"], function (props) {
  return props.$type === HEADER_TYPE.Integrated ? css(["top:70px;"]) : css(["bottom:0;"]);
}, Colors.white, function (props) {
  return props.$type === HEADER_TYPE.Integrated ? '0' : "solid 1px " + Colors.black40;
}, function (props) {
  return props.$type === HEADER_TYPE.Integrated ? "solid 1px " + Colors.black40 : '0';
}, breakpointLG);
var CustomLink$8 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1oityht-1"
})(["&.MuiLink-root{", " border:solid 1px ", ";color:", ";&:hover,&:focus,&:active{color:", ";background-color:", ";}}"], basicLinkStyle, Colors.blue60, Colors.blue60, Colors.blue60, Colors.white);
var RegistrationLink$1 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "RegistrationLink",
  componentId: "uh__sc-1oityht-2"
})(["&.MuiLink-root{", " margin-left:8px;color:", ";background-color:", ";&:hover,&:focus,&:active{background-color:", ";color:", ";}}"], basicLinkStyle, Colors.white, Colors.blue60, Colors.blue60, Colors.white);

var BottomSection = function BottomSection(_ref) {
  var actionItems = _ref.actionItems,
    headerType = _ref.headerType;
  return React__default.createElement(Wrapper$c, {
    "$type": headerType
  }, actionItems.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      href = _ref2.href,
      type = _ref2.type,
      callback = _ref2.callback;
    var props = {};
    if (href) {
      props.href = href;
    }
    return React__default.createElement(Fragment, {
      key: id
    }, type === ACTION_TYPE.Login ? React__default.createElement(CustomLink$8, Object.assign({}, props, {
      underline: "none"
    }), title) : React__default.createElement(RegistrationLink$1, Object.assign({}, props, {
      underline: "none",
      onClick: callback ? callback : undefined
    }), title));
  }));
};

var InfoSection$1 = /*#__PURE__*/styled.section.withConfig({
  displayName: "InfoSection",
  componentId: "uh__sc-122dbd8-0"
})(["flex:1;padding:16px;box-sizing:border-box;display:flex;flex-direction:column;border-bottom:solid 1px ", ";"], Colors.black40);
var Wrapper$d = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-122dbd8-2"
})(["display:block;width:100%;"]);

var CustomerMenuContainer$1 = function CustomerMenuContainer(_ref) {
  var customer = _ref.customer;
  if (typeof customer === 'undefined') {
    return null;
  }
  var displayName = customer.displayName,
    fullName = customer.fullName,
    accountIds = customer.accountIds;
  return React__default.createElement(Wrapper$d, null, React__default.createElement(InfoSection$1, null, React__default.createElement(UserSection, {
    displayName: displayName,
    fullName: fullName,
    accountIds: accountIds
  })));
};

var CustomNav$1 = /*#__PURE__*/styled.nav.withConfig({
  displayName: "CustomNav",
  componentId: "uh__sc-ulyn9g-0"
})(["flex:1;display:flex;margin:24px 0 180px;display:", ";"], function (props) {
  return props.$type === HEADER_TYPE.Integrated ? 'none' : 'initial';
});
var CustomSection = /*#__PURE__*/styled.section.withConfig({
  displayName: "CustomSection",
  componentId: "uh__sc-ulyn9g-1"
})(["flex:1;margin:0;padding:0;"]);
var CustomLink$9 = /*#__PURE__*/styled(StyledLink).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-ulyn9g-3"
})(["flex:1;display:flex;justify-content:space-between;align-items:center;", " color:", ";&.MuiLink-root{&:hover,&:focus,&:active{color:", ";text-decoration:none;background:none;}}.MuiSvgIcon-root{font-size:30px;}"], fontRegular24, Colors.black80, function (props) {
  return props.$isActive ? Colors.blue60 : Colors.black80;
});
var CustomBadge$1 = /*#__PURE__*/styled(Badge).withConfig({
  displayName: "CustomBadge",
  componentId: "uh__sc-ulyn9g-4"
})([".MuiBadge-badge{right:-8px;}"]);

var HEDER_TAG = 'HEADER';
var MobilePanel = function MobilePanel(_ref) {
  var type = _ref.type,
    navItems = _ref.navItems,
    customer = _ref.customer,
    actionItems = _ref.actionItems,
    setMobilePanelDisplay = _ref.setMobilePanelDisplay;
  var closeMobilePanel = function closeMobilePanel(e) {
    var target = e.target;
    if (target.tagName !== HEDER_TAG) {
      setMobilePanelDisplay(false);
    }
  };
  var computedActionItems = actionItems;
  if (customer) {
    var customerActionItems = customer.actionItems;
    computedActionItems = [_extends({}, customerActionItems[0], {
      type: ACTION_TYPE.Registration
    })];
  }
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(CustomerMenuContainer$1, {
    customer: customer
  }), React__default.createElement(CustomNav$1, {
    "$type": type
  }, React__default.createElement(CustomSection, null, navItems.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      subMenus = _ref2.subMenus,
      _ref2$enableBadge = _ref2.enableBadge,
      enableBadge = _ref2$enableBadge === void 0 ? false : _ref2$enableBadge,
      href = _ref2.href;
    var showBadge = enableBadge === true && (customer == null ? void 0 : customer.showUnreadMessage) === true;
    var isActive = getActiveStatus(subMenus, href);
    var mainHref = isEmpty(href) ? undefined : href;
    return React__default.createElement(CustomAccordion, {
      key: id,
      id: id
    }, React__default.createElement(CustomAccordionSummary, {
      href: href
    }, React__default.createElement(CustomLink$9, {
      "$isActive": isActive,
      href: mainHref,
      underline: "none"
    }, React__default.createElement(CustomBadge$1, {
      variant: "dot",
      invisible: !showBadge,
      color: "error"
    }, title))), React__default.createElement(CustomAccordionDetails, null, React__default.createElement(SubMenuContainer, {
      subMenus: subMenus,
      clickCallback: closeMobilePanel
    })));
  }), customer != null && customer.subMenus ? React__default.createElement(CustomAccordion, {
    key: "account-mobile-menu"
  }, React__default.createElement(CustomAccordionSummary, {
    href: undefined
  }, React__default.createElement(CustomLink$9, {
    "$isActive": undefined,
    href: undefined,
    underline: "none"
  }, React__default.createElement(ManageAccountsIcon, null))), React__default.createElement(CustomAccordionDetails, null, React__default.createElement(SubMenuSection, {
    items: customer.subMenus
  }))) : null)), computedActionItems ? React__default.createElement(BottomSection, {
    actionItems: computedActionItems,
    headerType: type
  }) : null);
};

var BalanceContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "BalanceContainer",
  componentId: "uh__sc-1ngwf7t-0"
})(["", " margin:14px 10px 0;padding:16px;box-shadow:0px 1px 4px rgba(182,182,182,0.5);border-radius:4px;@media (min-width:", "){display:flex;width:max-content;margin-left:auto;padding:12px 22px;margin:8px 0 0 auto;}"], fontRegular16, breakpointLG);
var BalanceItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "BalanceItem",
  componentId: "uh__sc-1ngwf7t-1"
})(["display:flex;justify-content:space-between;&:last-child{margin:8px 0 0;}@media (min-width:", "){display:flex;gap:4px;&:last-child{margin:0 0 0 20px;}}"], breakpointLG);
var negativeAmount = /*#__PURE__*/css(["color:", ";background-color:", ";padding:2px 4px;"], Colors.error100, Colors.error10);
var AmountLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "AmountLabel",
  componentId: "uh__sc-1ngwf7t-2"
})(["", ",", ""], fontSemibold16, function (_ref) {
  var $isNegative = _ref.$isNegative;
  return $isNegative && negativeAmount;
});

var StyledTooltip = /*#__PURE__*/withStyles({
  tooltip: {
    color: Colors.black80,
    backgroundColor: Colors.white,
    borderRadius: '4px',
    boxShadow: '0 1px 8px 0 rgba(0, 0, 0, .10), 0px 2px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.15)',
    padding: '8px',
    fontSize: 14
  }
})(Tooltip$1);

var NotAvailableBalance = function NotAvailableBalance(_ref) {
  var notAvailableMessage = _ref.notAvailableMessage;
  return React__default.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    spacing: 1
  }, React__default.createElement(StyledTooltip, {
    title: notAvailableMessage == null ? void 0 : notAvailableMessage.tooltipText,
    placement: "bottom-start"
  }, React__default.createElement(InfoOutlinedIcon, null)), React__default.createElement(Typography$1, {
    fontSize: 16,
    fontWeight: 600
  }, notAvailableMessage == null ? void 0 : notAvailableMessage.title));
};

var BalanceLabel = function BalanceLabel(_ref) {
  var label = _ref.label,
    dataTestId = _ref.dataTestId;
  return label ? React__default.createElement("span", {
    "data-testid": dataTestId
  }, label, " ") : null;
};
var BalanceContainer$1 = function BalanceContainer$1(_ref2) {
  var _customer$totalBalanc, _customer$totalBalanc2, _customer$totalBalanc3, _customer$availableBa, _customer$availableBa2, _customer$availableBa3;
  var type = _ref2.type,
    customer = _ref2.customer;
  var isCustomerActive = (customer == null ? void 0 : customer.state) === 'ACTIVE';
  if (type !== HEADER_TYPE.Private || !isCustomerActive) return null;
  return React__default.createElement(BalanceContainer, null, React__default.createElement(BalanceItem, null, React__default.createElement(BalanceLabel, {
    label: customer == null ? void 0 : (_customer$totalBalanc = customer.totalBalance) == null ? void 0 : _customer$totalBalanc.label,
    dataTestId: "total-balance"
  }), customer != null && customer.balanceIsNotAvailable ? React__default.createElement(NotAvailableBalance, {
    notAvailableMessage: customer == null ? void 0 : customer.notAvailableMessage
  }) : React__default.createElement(AmountLabel, {
    "$isNegative": customer == null ? void 0 : (_customer$totalBalanc2 = customer.totalBalance) == null ? void 0 : _customer$totalBalanc2.isNegative
  }, customer == null ? void 0 : (_customer$totalBalanc3 = customer.totalBalance) == null ? void 0 : _customer$totalBalanc3.amount)), React__default.createElement(BalanceItem, null, React__default.createElement(BalanceLabel, {
    label: customer == null ? void 0 : (_customer$availableBa = customer.availableBalance) == null ? void 0 : _customer$availableBa.label,
    dataTestId: "available-balance"
  }), customer != null && customer.balanceIsNotAvailable ? React__default.createElement(NotAvailableBalance, {
    notAvailableMessage: customer == null ? void 0 : customer.notAvailableMessage
  }) : React__default.createElement(AmountLabel, {
    "$isNegative": customer == null ? void 0 : (_customer$availableBa2 = customer.availableBalance) == null ? void 0 : _customer$availableBa2.isNegative
  }, customer == null ? void 0 : (_customer$availableBa3 = customer.availableBalance) == null ? void 0 : _customer$availableBa3.amount)));
};

var BASE_HEIGHT = '64px';
var LG_BASE_HEIGHT = '56px';
var Wrapper$e = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1192ihj-0"
})(["position:relative;box-sizing:border-box;background-color:", ";&.navWrapper:after{content:'';position:absolute;width:100%;height:1px;background:", ";display:flex;align-items:center;right:0;left:0;top:", ";z-index:10;}@media (min-width:", "){&.navWrapper:after{top:", ";}}"], Colors.white, Colors.black20, BASE_HEIGHT, breakpointLG, LG_BASE_HEIGHT);
var CustomHeader = /*#__PURE__*/styled.header.withConfig({
  displayName: "CustomHeader",
  componentId: "uh__sc-1192ihj-1"
})(["max-width:1440px;height:100%;margin:0 auto;"]);
var SectionWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SectionWrapper",
  componentId: "uh__sc-1192ihj-2"
})(["display:flex;align-items:center;flex:1;justify-content:", ";"], function (props) {
  return props.$type === HEADER_TYPE.Private || !props.$hasDataSource ? 'space-between' : 'flex-start';
});
var TopNav = /*#__PURE__*/styled.div.withConfig({
  displayName: "TopNav",
  componentId: "uh__sc-1192ihj-3"
})(["display:flex;align-items:center;padding:0 16px;min-height:", ";@media (min-width:", "){justify-content:space-between;min-height:", ";}"], BASE_HEIGHT, breakpointLG, LG_BASE_HEIGHT);

var DefaultSkeleton = function DefaultSkeleton() {
  return React__default.createElement(Wrapper$e, {
    className: "navWrapper",
    "aria-label": "loading nav"
  }, React__default.createElement(CustomHeader, null, React__default.createElement(TopNav, null, React__default.createElement(SectionWrapper, {
    "$hasDataSource": false
  }, React__default.createElement(Skeleton$2, {
    variant: "rounded",
    width: 120,
    height: 24
  }), React__default.createElement(Skeleton$2, {
    variant: "rounded",
    width: 24,
    height: 24
  })))));
};
var UnifiedNavigation = function UnifiedNavigation(_ref) {
  var dataSource = _ref.dataSource;
  var _useState = useState(false),
    mobilePanelDisplay = _useState[0],
    setMobilePanelDisplay = _useState[1];
  if (!dataSource) {
    return React__default.createElement(DefaultSkeleton, null);
  }
  var type = dataSource.type,
    logoItems = dataSource.logoItems,
    navItems = dataSource.navItems,
    actionItems = dataSource.actionItems,
    customer = dataSource.customer,
    isHeaderDataLoading = dataSource.isHeaderDataLoading;
  var shouldShowPrivateLoader = type === HEADER_TYPE.Private && isHeaderDataLoading;
  return React__default.createElement(ThemeProvider, {
    theme: theme$1
  }, React__default.createElement(Wrapper$e, {
    className: "navWrapper"
  }, React__default.createElement(CustomHeader, null, React__default.createElement(TopNav, null, React__default.createElement(SectionWrapper, {
    "$type": type,
    "$hasDataSource": true
  }, React__default.createElement(LogoSection, {
    logoItems: logoItems
  }), navItems ? React__default.createElement(Navigation, {
    type: type,
    navItems: navItems,
    customer: customer,
    shouldShowPrivateLoader: shouldShowPrivateLoader
  }) : null), actionItems && type !== HEADER_TYPE.Private ? React__default.createElement(ActionsSection, {
    actionItems: actionItems
  }) : null, navItems ? React__default.createElement(HamburgerSection, {
    mobilePanelDisplay: mobilePanelDisplay,
    setMobilePanelDisplay: setMobilePanelDisplay,
    shouldShowPrivateLoader: shouldShowPrivateLoader
  }) : null), React__default.createElement(BalanceContainer$1, {
    type: type,
    customer: customer
  })), navItems ? React__default.createElement(MobilePanelContainer, {
    mobilePanelDisplay: mobilePanelDisplay
  }, React__default.createElement(MobilePanel, {
    type: type,
    navItems: navItems,
    customer: customer,
    actionItems: actionItems,
    setMobilePanelDisplay: setMobilePanelDisplay
  })) : null));
};

var breakpointSM = '576px';
var breakpointMD = '768px';
var breakpointLG$1 = '1024px';

var _styled$img$withConfi;
var Wrapper$f = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1w11mw2-0"
})({
  display: 'flex',
  height: 48
});
var CustomLink$a = /*#__PURE__*/styled(Link).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1w11mw2-1"
})({
  display: 'flex',
  alignItems: 'center',
  margin: '0 24px 0 0',
  padding: '0 24px 0 0',
  borderRight: "solid 1px " + Colors.grey200,
  '&:last-child': {
    borderRight: 0,
    margin: 0,
    padding: 0
  }
});
var CustomImage$1 = /*#__PURE__*/styled.img.withConfig({
  displayName: "CustomImage",
  componentId: "uh__sc-1w11mw2-2"
})((_styled$img$withConfi = {
  maxWidth: 124,
  minWidth: 0,
  maxHeight: 24
}, _styled$img$withConfi["@media (min-width: " + breakpointLG$1 + ")"] = {
  maxWidth: 180,
  maxHeight: 31
}, _styled$img$withConfi));

var LogoSection$1 = function LogoSection(_ref) {
  var logoItems = _ref.logoItems;
  return React__default.createElement(Wrapper$f, null, logoItems.map(function (_ref2) {
    var id = _ref2.id,
      href = _ref2.href,
      url = _ref2.url,
      alt = _ref2.alt;
    return React__default.createElement(CustomLink$a, {
      key: id,
      href: href
    }, React__default.createElement(CustomImage$1, {
      src: url,
      alt: alt
    }));
  }));
};

var ArrowDown = function ArrowDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? Colors.grey900 : _ref$color;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, createElement("path", {
    d: "M6 9L12 15L18 9",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }));
};

var _excluded$2 = ["className"];
var CustomTooltip$1 = /*#__PURE__*/styled$1(function (_ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return React__default.createElement(Tooltip, Object.assign({}, props, {
    classes: {
      popper: className
    },
    slotProps: {
      popper: {
        keepMounted: true,
        disablePortal: true
      }
    }
  }));
})(function () {
  var _ref2;
  return _ref2 = {}, _ref2["." + tooltipClasses.popper + "& ." + tooltipClasses.tooltip] = {
    boxShadow: 'none',
    padding: '16px 0',
    margin: 0,
    minWidth: 332,
    backgroundColor: "" + Colors.white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 32,
    borderBottomRightRadius: 32,
    marginTop: 13,
    borderLeft: "1px solid " + Colors.cream100,
    borderRight: "1px solid " + Colors.cream100,
    borderBottom: "1px solid " + Colors.cream100,
    marginLeft: '-24px'
  }, _ref2['&.private .MuiTooltip-tooltip'] = {
    marginTop: 10,
    marginLeft: 0
  }, _ref2;
});

var HEADER_TYPE$1;
(function (HEADER_TYPE) {
  HEADER_TYPE["Public"] = "public";
  HEADER_TYPE["Private"] = "private";
  HEADER_TYPE["Integrated"] = "integrated";
})(HEADER_TYPE$1 || (HEADER_TYPE$1 = {}));
var ACTION_TYPE$1;
(function (ACTION_TYPE) {
  ACTION_TYPE["Login"] = "login";
  ACTION_TYPE["Registration"] = "registration";
})(ACTION_TYPE$1 || (ACTION_TYPE$1 = {}));
var MENU_LAYOUT$1;
(function (MENU_LAYOUT) {
  MENU_LAYOUT["Even"] = "even";
  MENU_LAYOUT["Default"] = "default";
})(MENU_LAYOUT$1 || (MENU_LAYOUT$1 = {}));
var MENU_TYPE$1;
(function (MENU_TYPE) {
  MENU_TYPE["Basic"] = "basic";
  MENU_TYPE["Advanced"] = "advanced";
  MENU_TYPE["Text"] = "text";
  MENU_TYPE["Image"] = "image";
  MENU_TYPE["Arrow"] = "arrow";
})(MENU_TYPE$1 || (MENU_TYPE$1 = {}));

var CopyIban = function CopyIban() {
  return createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("g", null, createElement("path", {
    d: "M8 3H14.24C14.52 3 14.78 3.11 14.97 3.31L18.73 7.3C18.9 7.49 19 7.73 19 7.99V15M13 14H7M11 17H7M15 21H6C5.45 21 5 20.55 5 20V7C5 6.45 5.45 6 6 6H12.87C13.15 6 13.43 6.12 13.62 6.33L15.75 8.71C15.91 8.89 16 9.13 16 9.38V20C16 20.55 15.55 21 15 21Z",
    stroke: "#1D5A9A",
    strokeWidth: "2"
  })));
};

var HamburgerIcon = function HamburgerIcon() {
  return createElement("svg", {
    className: "hamburgerIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, createElement("path", {
    d: "M10 13H30M10 20H30M10 27H30",
    stroke: "#00183C",
    strokeWidth: "2"
  }));
};

var HamburgerCloseIcon = function HamburgerCloseIcon() {
  return createElement("svg", {
    className: "closeIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, createElement("path", {
    d: "M19 19L5 5M19 5L5 19",
    stroke: "#00183C",
    strokeWidth: "2"
  }));
};

var stringAvatar$1 = function stringAvatar(name) {
  if (typeof name === 'undefined') {
    return undefined;
  }
  var nameArray = name.split(' ');
  return "" + nameArray[0][0] + nameArray.slice(-1)[0][0];
};
var copyHandler$1 = function copyHandler(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  }
};
var isActiveMenu$1 = function isActiveMenu(href) {
  if (href === void 0) {
    href = '';
  }
  if (isCSR()) {
    var pathname = window.location.pathname;
    var hash = window.location.hash;
    return ("" + pathname + hash).toLowerCase() === href.toLowerCase();
  }
  return false;
};
var getActiveStatus$1 = function getActiveStatus(subMenus, href) {
  if (!subMenus) return isActiveMenu$1(href);
  var items = Object.values(subMenus).reduce(function (accumulator, currentValue) {
    return [].concat(accumulator, Array.isArray(currentValue) ? currentValue : []);
  }, []);
  return items.some(function (item) {
    return isActiveMenu$1(item == null ? void 0 : item.href);
  });
};
var isTablet$1 = function isTablet() {
  if (!isCSR()) {
    return false;
  }
  return navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
};

var fontRegularCommon$1 = /*#__PURE__*/css(["font-family:", ";font-style:normal;font-weight:normal;"], typography.fontFamily);
var fontRegular16$1 = /*#__PURE__*/css(["", ";font-size:16px;line-height:24px;"], fontRegularCommon$1);
var body1 = /*#__PURE__*/css(["font-family:", ";font-size:16px;font-style:normal;font-weight:400;line-height:24px;letter-spacing:-0.12px;"], typography.fontFamilyV2);
var subTitle2 = /*#__PURE__*/css(["font-family:", ";font-size:16px;font-style:normal;font-weight:500;line-height:28px;letter-spacing:-0.12px;@media (max-width:", "){font-size:18px;font-weight:500;line-height:24px;}"], typography.fontFamilyV2, breakpointLG$1);
var button = /*#__PURE__*/css(["font-family:", ";font-size:16px;font-style:normal;font-weight:500;line-height:24px;letter-spacing:-0.12px;"], typography.fontFamilyV2);

var StyledLinkV2 = /*#__PURE__*/withTheme( /*#__PURE__*/styled(Link).withConfig({
  displayName: "StyledLinkV2",
  componentId: "uh__sc-l82d1q-1"
})(["&.MuiLink-root{color:", ";font-weight:500;text-decoration:none;transition:background-color 250ms cubic-bezier(0.4,0,0.2,1),box-shadow 250ms cubic-bezier(0.4,0,0.2,1),border-color 250ms cubic-bezier(0.4,0,0.2,1),color 250ms cubic-bezier(0.4,0,0.2,1);&:hover{color:", ";}&:hover,&:focus,&:active{font-weight:500;text-decoration:none;cursor:pointer;}&:focus,&:active{color:", ";}}"], function (props) {
  return props.$isActive ? Colors.blue400 : Colors.grey900;
}, function (props) {
  return props.$isActive ? Colors.blue400 : Colors.grey900;
}, Colors.blue400));

var CustomLink$b = /*#__PURE__*/styled(StyledLinkV2).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1ose8ct-0"
})(["&.MuiLink-root{display:flex;padding:8px;margin:0 0 16px 0;border:2px solid transparent;", ";border-radius:12px;&:hover{color:", ";background-color:", ";}&:focus,&:active{border:2px solid ", ";color:", ";}}&:last-child{margin:0;}"], button, Colors.blue400, Colors.white, Colors.blue300, Colors.grey900);

var TextSubMenu$1 = function TextSubMenu(_ref) {
  var item = _ref.item;
  var href = item.href,
    title = item.title,
    callback = item.callback;
  var mainHref = isEmpty(href) ? undefined : href;
  return React__default.createElement(CustomLink$b, {
    href: mainHref,
    underline: "none",
    "$isActive": isActiveMenu$1(href),
    onClick: callback ? callback : undefined
  }, title);
};

var SubMenuSection$1 = function SubMenuSection(_ref) {
  var items = _ref.items;
  if (typeof items === 'undefined') {
    return null;
  }
  return React__default.createElement(React__default.Fragment, null, items.map(function (item) {
    return item ? React__default.createElement(Fragment, {
      key: item.id
    }, React__default.createElement(TextSubMenu$1, {
      item: item
    })) : null;
  }));
};

var desktopStyles$1 = /*#__PURE__*/css(function (props) {
  return {
    minWidth: 'auto',
    maxWidth: props.$layout === MENU_LAYOUT$1.Even ? 'auto' : '580px',
    padding: '0 16px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    '.MuiLink-root:last-child': {
      marginBottom: 0
    },
    '.top': {
      flex: 1,
      padding: '8px 0',
      display: 'flex',
      boxSizing: 'border-box'
    },
    '.middle': {
      display: 'flex',
      boxSizing: 'border-box'
    },
    '.main': {
      flex: props.$layout === MENU_LAYOUT$1.Even ? '1' : '0 1 auto',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column'
    },
    '.sidebar': {
      maxWidth: props.$layout === MENU_LAYOUT$1.Even ? 'auto' : '200px',
      minWidth: props.$layout === MENU_LAYOUT$1.Even ? 'auto' : '200px',
      boxSizing: 'border-box',
      flex: props.$layout === MENU_LAYOUT$1.Even ? '1' : '0 0 200px',
      padding: props.$layout === MENU_LAYOUT$1.Even ? '16px 0' : '16px 8px',
      borderTop: "solid 1px " + Colors.black40,
      borderLeft: "solid 1px " + Colors.black40
    },
    '.bottom': {
      flex: 1,
      padding: 16,
      boxSizing: 'border-box',
      borderTop: "solid 1px " + Colors.black40
    }
  };
});
var mobileStyles$1 = /*#__PURE__*/css(function (props) {
  return {
    minWidth: props.$layout === MENU_LAYOUT$1.Even ? '340px' : 'auto',
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    '.top': {
      padding: '0',
      boxSizing: 'border-box'
    },
    '.main': {
      flex: 1,
      padding: '4px 0',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column'
    },
    '.sidebar': {
      display: props.$layout === MENU_LAYOUT$1.Even ? 'flex' : 'none',
      flexDirection: 'column',
      boxSizing: 'border-box',
      flex: 1,
      padding: props.$layout === MENU_LAYOUT$1.Even ? '16px 0' : '16px 8px',
      borderLeft: "solid 1px " + Colors.black40
    },
    '.bottom': {
      display: props.$layout === MENU_LAYOUT$1.Even ? 'flex' : 'none',
      padding: '0 8px',
      boxSizing: 'border-box',
      '&:before': {
        content: "''",
        display: 'flex',
        margin: 8,
        borderBottom: "solid 1px " + Colors.black40
      }
    }
  };
});
var Wrapper$g = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1kuesmn-0"
})(function (props) {
  return props.$isMobile === true ? mobileStyles$1 : desktopStyles$1;
});

var SubMenuContainer$1 = function SubMenuContainer(_ref) {
  var subMenus = _ref.subMenus,
    clickCallback = _ref.clickCallback;
  var theme = useTheme();
  var _useViewports = useViewports(theme),
    isMobile = _useViewports.isMobile;
  if (typeof subMenus === 'undefined') {
    return null;
  }
  var top = subMenus.top,
    main = subMenus.main,
    sidebar = subMenus.sidebar,
    bottom = subMenus.bottom,
    _subMenus$layout = subMenus.layout,
    layout = _subMenus$layout === void 0 ? MENU_LAYOUT$1.Default : _subMenus$layout;
  return React__default.createElement(Wrapper$g, {
    "$layout": layout,
    "$isMobile": isMobile,
    onClick: clickCallback
  }, !isEmpty(compact(top)) ? React__default.createElement(SubMenuSection$1, {
    items: top
  }) : null, React__default.createElement("div", null, !isEmpty(compact(main)) ? React__default.createElement(SubMenuSection$1, {
    items: main
  }) : null, !isEmpty(compact(sidebar)) ? React__default.createElement(SubMenuSection$1, {
    items: sidebar
  }) : null), !isEmpty(compact(bottom)) ? React__default.createElement(SubMenuSection$1, {
    items: bottom
  }) : null);
};

var _excluded$3 = ["className"];
var CopiedTooltip$1 = /*#__PURE__*/styled$1(function (_ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React__default.createElement(Tooltip, Object.assign({}, props, {
    classes: {
      popper: className
    }
  }));
})(function () {
  var _ref2;
  return _ref2 = {}, _ref2["." + tooltipClasses.popper + "& ." + tooltipClasses.tooltip + " .MuiSvgIcon-root"] = {
    fontSize: '24px'
  }, _ref2;
});

var Wrapper$h = /*#__PURE__*/styled.section.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-z0tlxf-0"
})(["display:flex;align-items:center;"]);
var FullName$1 = /*#__PURE__*/styled(Typography$1).withConfig({
  displayName: "FullName",
  componentId: "uh__sc-z0tlxf-2"
})(["&.MuiTypography-root.MuiTypography-body1{padding:0;width:100%;display:block;text-align:left;margin-bottom:8px;color:", ";", ";}"], Colors.grey900, button);
var Iban = /*#__PURE__*/styled(Typography$1).withConfig({
  displayName: "Iban",
  componentId: "uh__sc-z0tlxf-3"
})(["&.MuiTypography-root.MuiTypography-body1{color:", ";", ";}"], Colors.grey500, body1);
var Container$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "uh__sc-z0tlxf-4"
})(["flex:1;"]);
var AccountWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccountWrapper",
  componentId: "uh__sc-z0tlxf-5"
})(["display:flex;justify-content:space-between;align-items:center;"]);
var AccountLabel$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccountLabel",
  componentId: "uh__sc-z0tlxf-6"
})(["", ";color:", ";"], fontRegular16$1, Colors.black80);
var AccountId$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccountId",
  componentId: "uh__sc-z0tlxf-7"
})(["display:flex;align-items:center;", ";color:", ";"], fontRegular16$1, Colors.black80);
var CopyIconButton = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "CopyIconButton",
  componentId: "uh__sc-z0tlxf-8"
})(["&.MuiButtonBase-root.MuiButton-root{min-width:24px;padding:0;&:hover{background-color:transparent;path{stroke:", ";}}}"], Colors.blue400);

var AUTO_HIDE_DURATION$1 = 3000;
var UserSection$1 = function UserSection(_ref) {
  var fullName = _ref.fullName,
    accountIds = _ref.accountIds,
    isDropdownOpen = _ref.isDropdownOpen;
  var theme = useTheme();
  var _useViewports = useViewports(theme),
    isMobile = _useViewports.isMobile;
  var _useState = useState(),
    openedId = _useState[0],
    setOpenedId = _useState[1];
  var clickHandler = function clickHandler(id) {
    copyHandler$1(IBAN.isValid(id) ? IBAN.electronicFormat(id) : id);
    setOpenedId(id);
  };
  useEffect(function () {
    var timer;
    if (openedId) {
      timer = setTimeout(function () {
        setOpenedId(undefined);
      }, AUTO_HIDE_DURATION$1);
    }
    return function () {
      clearTimeout(timer);
    };
  }, [openedId]);
  useEffect(function () {
    if (!isDropdownOpen) {
      setOpenedId(undefined);
    }
  }, [isDropdownOpen]);
  return React__default.createElement(Wrapper$h, null, React__default.createElement(Container$1, null, React__default.createElement(FullName$1, null, fullName), accountIds.map(function (_ref2) {
    var id = _ref2.id,
      label = _ref2.label;
    return React__default.createElement(AccountWrapper$1, {
      key: id
    }, label ? React__default.createElement(AccountLabel$1, null, label) : null, id ? React__default.createElement(AccountId$1, null, React__default.createElement(Iban, null, IBAN.isValid(id) ? IBAN.printFormat(id, ' ') : id), React__default.createElement(CopiedTooltip$1, {
      title: React__default.createElement(CheckCircleOutlineIcon, null),
      placement: "top",
      open: isMobile ? openedId === id : openedId === id && isDropdownOpen,
      arrow: true
    }, React__default.createElement(CopyIconButton, {
      onClick: function onClick() {
        return clickHandler(id);
      },
      endIcon: React__default.createElement(CopyIban, null)
    }))) : null);
  })));
};

var Wrapper$i = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-p3gqo2-0"
})(["min-width:332px;flex:1;display:flex;flex-direction:column;"]);
var InfoSection$2 = /*#__PURE__*/styled.section.withConfig({
  displayName: "InfoSection",
  componentId: "uh__sc-p3gqo2-1"
})(["flex:1;padding:0 24px 0 24px;box-sizing:border-box;display:flex;flex-direction:column;"]);
var MenuSection$1 = /*#__PURE__*/styled.section.withConfig({
  displayName: "MenuSection",
  componentId: "uh__sc-p3gqo2-2"
})(["flex:1;padding:16px 0;box-sizing:border-box;display:flex;flex-direction:column;"]);
var SubMenus = /*#__PURE__*/styled.div.withConfig({
  displayName: "SubMenus",
  componentId: "uh__sc-p3gqo2-3"
})(["padding:16px;"]);
var ActionSections = /*#__PURE__*/styled.div.withConfig({
  displayName: "ActionSections",
  componentId: "uh__sc-p3gqo2-4"
})(["flex:1;display:flex;justify-content:flex-end;padding:0 16px 0 0;"]);
var ActionButton = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "ActionButton",
  componentId: "uh__sc-p3gqo2-5"
})(["&.MuiButtonBase-root{border:2px solid ", ";border-radius:12px;padding:8px;height:52px;color:", ";", ";&:hover{background-color:", ";color:", ";border:2px solid ", ";}&:focus,&:active{background-color:", ";border:2px solid ", ";outline:2px solid ", ";outline-offset:-4px;}}"], Colors.blue300, Colors.grey900, button, Colors.blue400, Colors.grey900, Colors.blue400, Colors.blue300, Colors.blue300, Colors.white);

var CustomerMenuContainer$2 = function CustomerMenuContainer(_ref) {
  var isDropdownOpen = _ref.isDropdownOpen,
    customer = _ref.customer;
  if (typeof customer === 'undefined') {
    return null;
  }
  var displayName = customer.displayName,
    fullName = customer.fullName,
    accountIds = customer.accountIds,
    subMenus = customer.subMenus,
    actionItems = customer.actionItems;
  return React__default.createElement(Wrapper$i, null, React__default.createElement(InfoSection$2, null, React__default.createElement(UserSection$1, {
    isDropdownOpen: isDropdownOpen,
    displayName: displayName,
    fullName: fullName,
    accountIds: accountIds
  })), subMenus ? React__default.createElement(SubMenus, null, React__default.createElement(Divider, null), React__default.createElement(MenuSection$1, null, subMenus.map(function (item) {
    return item ? React__default.createElement(Fragment, {
      key: item.id
    }, React__default.createElement(TextSubMenu$1, {
      item: item
    })) : null;
  })), React__default.createElement(Divider, null)) : null, React__default.createElement(ActionSections, null, actionItems.map(function (item) {
    return React__default.createElement(Fragment, {
      key: item.id
    }, React__default.createElement(ActionButton, {
      variant: "outlined",
      size: "small",
      onClick: item.callback ? item.callback : undefined
    }, item.title));
  })));
};

var CUSTOMER_PRIVATE_MENU$1 = 'customerPrivateMenu';
var DEFAULT_PROPS$1 = {
  TransitionComponent: Fade,
  disableFocusListener: true,
  placement: 'bottom-start'
};
var LAPTOP_PROPS$1 = {
  enterDelay: 50
};
var TABLET_PROPS$1 = {
  disableHoverListener: true,
  disableTouchListener: true
};

var bgcolor$1 = '#ebebeb';
var Skeleton$1 = function Skeleton(props) {
  return React__default.createElement(Skeleton$2, Object.assign({
    "aria-label": "skeleton-loader"
  }, props, {
    sx: {
      bgcolor: bgcolor$1
    },
    animation: "wave"
  }));
};

var CustomNav$2 = /*#__PURE__*/styled.nav.withConfig({
  displayName: "CustomNav",
  componentId: "uh__sc-1kj6myb-0"
})(["display:none;@media (min-width:", "){display:", ";}"], breakpointLG$1, function (_ref) {
  var $type = _ref.$type;
  return $type === HEADER_TYPE$1.Integrated ? 'none' : 'block';
});
var CustomList$1 = /*#__PURE__*/styled.ul.withConfig({
  displayName: "CustomList",
  componentId: "uh__sc-1kj6myb-1"
})(["margin:0;padding:0;display:flex;align-items:center;list-style-type:none;"]);
var CustomLink$c = /*#__PURE__*/styled(StyledLinkV2).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1kj6myb-2"
})(["", ";color:", ";padding:12px 16px;border-radius:12px;border:2px solid transparent;&.background{background-color:rgba(48,150,255,0.24);&:focus,&:active{border:2px solid ", ";background-color:", ";}}"], button, Colors.grey900, Colors.blue300, Colors.white);
var CustomListItem$1 = /*#__PURE__*/styled.li.withConfig({
  displayName: "CustomListItem",
  componentId: "uh__sc-1kj6myb-3"
})(["margin-right:8px;display:flex;align-items:center;&:last-of-type{margin-right:0;}.MuiButton-root.avatarButton{margin-left:16px;&:hover{background-color:transparent;}}.avatarName{height:48px;width:48px;color:", ";background-color:", ";border:1px solid ", ";border-radius:8px;box-sizing:border-box;", ";}.arrowDown{height:24px;margin-left:8px;color:", ";transform-origin:center;transition:transform 0.2s ease-in-out;}.rotateArrowDown{transform:rotate(-180deg);}"], Colors.grey900, Colors.white, Colors.cream100, button, Colors.black80);
var CustomBadge$2 = /*#__PURE__*/styled(Badge).withConfig({
  displayName: "CustomBadge",
  componentId: "uh__sc-1kj6myb-4"
})([".MuiBadge-badge{right:-8px;}"]);
var CustomBox$1 = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CustomBox",
  componentId: "uh__sc-1kj6myb-5"
})(["display:flex;align-items:center;column-gap:16px;"]);

var PrivateLoader$1 = function PrivateLoader(_ref) {
  var _ref$skeletonColumns = _ref.skeletonColumns,
    skeletonColumns = _ref$skeletonColumns === void 0 ? 4 : _ref$skeletonColumns;
  var columns = new Array(skeletonColumns).fill(null);
  return React__default.createElement(CustomBox$1, {
    "aria-label": "loading",
    role: "presentation"
  }, columns.map(function (_, index) {
    return React__default.createElement(Skeleton$1, {
      key: index,
      variant: "rounded",
      width: 110,
      height: 24
    });
  }), React__default.createElement(Skeleton$1, {
    variant: "circular"
  }, React__default.createElement(Avatar, null)));
};

var Navigation$1 = function Navigation(_ref) {
  var type = _ref.type,
    navItems = _ref.navItems,
    customer = _ref.customer,
    shouldShowPrivateLoader = _ref.shouldShowPrivateLoader;
  var _useState = useState(),
    openedId = _useState[0],
    setOpenedId = _useState[1];
  var handleClose = function handleClose() {
    setOpenedId(undefined);
  };
  var handleOpen = function handleOpen(id) {
    setOpenedId(id);
  };
  var MainNavProps = _extends({}, DEFAULT_PROPS$1, isTablet$1() ? TABLET_PROPS$1 : LAPTOP_PROPS$1);
  if (shouldShowPrivateLoader) {
    return React__default.createElement(CustomNav$2, {
      "$type": type
    }, React__default.createElement(PrivateLoader$1, null));
  }
  return React__default.createElement(CustomNav$2, {
    "$type": type
  }, React__default.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, React__default.createElement(CustomList$1, null, navItems.map(function (_ref2) {
    var id = _ref2.id,
      href = _ref2.href,
      title = _ref2.title,
      subMenus = _ref2.subMenus,
      _ref2$enableBadge = _ref2.enableBadge,
      enableBadge = _ref2$enableBadge === void 0 ? false : _ref2$enableBadge;
    var showBadge = enableBadge === true && (customer == null ? void 0 : customer.showUnreadMessage) === true;
    var isActive = getActiveStatus$1(subMenus, href);
    var mainHref = isEmpty(href) ? undefined : href;
    return React__default.createElement(CustomTooltip$1, Object.assign({}, MainNavProps, {
      title: React__default.createElement(SubMenuContainer$1, {
        subMenus: subMenus,
        clickCallback: handleClose
      }),
      key: id,
      open: openedId === id,
      onClose: handleClose,
      onOpen: function onOpen() {
        return handleOpen(id);
      }
    }), React__default.createElement(CustomListItem$1, null, React__default.createElement(CustomLink$c, {
      href: mainHref,
      underline: "none",
      className: "" + (openedId === id ? 'background' : null),
      onClick: function onClick() {
        return handleOpen(id);
      },
      "$isActive": isActive
    }, React__default.createElement(CustomBadge$2, {
      variant: "dot",
      invisible: !showBadge,
      color: "error"
    }, title))));
  }), type === HEADER_TYPE$1.Private ? React__default.createElement(CustomTooltip$1, Object.assign({}, MainNavProps, {
    title: React__default.createElement(CustomerMenuContainer$2, {
      isDropdownOpen: openedId === CUSTOMER_PRIVATE_MENU$1,
      customer: customer
    }),
    key: CUSTOMER_PRIVATE_MENU$1,
    open: openedId === CUSTOMER_PRIVATE_MENU$1,
    onClose: handleClose,
    onOpen: function onOpen() {
      return handleOpen(CUSTOMER_PRIVATE_MENU$1);
    },
    className: "private"
  }), React__default.createElement(CustomListItem$1, null, React__default.createElement(Button$2, {
    className: "avatarButton",
    disableRipple: true,
    onClick: function onClick() {
      return handleOpen(CUSTOMER_PRIVATE_MENU$1);
    }
  }, React__default.createElement(Avatar, {
    className: "avatarName"
  }, stringAvatar$1(customer == null ? void 0 : customer.displayName)), React__default.createElement("i", {
    className: (openedId === CUSTOMER_PRIVATE_MENU$1 ? 'rotateArrowDown' : null) + " arrowDown"
  }, React__default.createElement(ArrowDown, {
    color: openedId === CUSTOMER_PRIVATE_MENU$1 ? Colors.blue400 : Colors.blue600
  }))))) : null)));
};

var Wrapper$j = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-wc9xp2-0"
})(["display:none;@media (min-width:", "){display:flex;}"], breakpointLG$1);
var CustomLink$d = /*#__PURE__*/styled(StyledLinkV2).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-wc9xp2-1"
})(["box-sizing:border-box;display:flex;align-items:center;background-color:transparent;border:2px solid ", ";border-radius:12px;padding:8px;height:48px;min-width:76px;max-width:300px;", " &:hover{background-color:", ";color:", ";border:2px solid ", ";}&.MuiLink-root{&:focus,&:active{color:", ";background-color:", ";border:2px solid ", ";outline:2px solid ", ";outline-offset:-4px;}}"], Colors.blue300, button, Colors.blue400, Colors.grey900, Colors.blue400, Colors.grey900, Colors.blue300, Colors.blue300, Colors.white);
var RegistrationLink$2 = /*#__PURE__*/styled(StyledLinkV2).withConfig({
  displayName: "RegistrationLink",
  componentId: "uh__sc-wc9xp2-2"
})(["box-sizing:border-box;display:flex;align-items:center;border:2px solid ", ";background-color:", ";margin-left:12px !important;border-radius:12px;padding:8px;height:48px;min-width:76px;max-width:300px;", " &:hover{background-color:", ";border:2px solid ", ";}&.MuiLink-root{&:focus,&:active{color:", ";border:2px solid ", ";outline:2px solid ", ";outline-offset:-4px;}}"], Colors.blue300, Colors.blue300, button, Colors.blue400, Colors.blue400, Colors.grey900, Colors.blue300, Colors.white);

var ActionsSection$1 = function ActionsSection(_ref) {
  var actionItems = _ref.actionItems;
  return React__default.createElement(Wrapper$j, null, actionItems.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      href = _ref2.href,
      type = _ref2.type;
    return React__default.createElement(Fragment, {
      key: id
    }, type === 'login' ? React__default.createElement(CustomLink$d, {
      href: href,
      underline: "none"
    }, title) : React__default.createElement(RegistrationLink$2, {
      href: href,
      underline: "none"
    }, title));
  }));
};

var MobilePrivateLoader$1 = function MobilePrivateLoader() {
  return React__default.createElement(Box$1, {
    "aria-label": "mobile loading",
    role: "presentation"
  }, React__default.createElement(Skeleton$1, {
    variant: "rounded",
    width: 24,
    height: 24
  }));
};

var _styled$div$withConfi;
var Wrapper$k = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1vzge8t-0"
})((_styled$div$withConfi = {
  display: 'flex'
}, _styled$div$withConfi["@media (min-width: " + breakpointLG$1 + ")"] = {
  display: 'none'
}, _styled$div$withConfi['.MuiButtonBase-root'] = {
  height: 56,
  width: 56,
  '.closeIcon': {
    height: 24,
    width: 24
  },
  '.hamburgerIcon': {
    height: 56,
    width: 56
  },
  '&:hover': {
    backgroundColor: 'transparent'
  }
}, _styled$div$withConfi['.iconButton'] = {
  marginRight: '-16px'
}, _styled$div$withConfi));

var HamburgerSection$1 = function HamburgerSection(_ref) {
  var mobilePanelDisplay = _ref.mobilePanelDisplay,
    setMobilePanelDisplay = _ref.setMobilePanelDisplay,
    shouldShowPrivateLoader = _ref.shouldShowPrivateLoader;
  var toggleMobilePanelHandler = function toggleMobilePanelHandler() {
    setMobilePanelDisplay(!mobilePanelDisplay);
  };
  if (shouldShowPrivateLoader) {
    return React__default.createElement(Wrapper$k, null, React__default.createElement(MobilePrivateLoader$1, null));
  }
  return React__default.createElement(Wrapper$k, null, React__default.createElement(IconButton$2, {
    className: "iconButton",
    onClick: toggleMobilePanelHandler,
    role: "button"
  }, mobilePanelDisplay ? React__default.createElement(HamburgerCloseIcon, null) : React__default.createElement(HamburgerIcon, null)));
};

var Wrapper$l = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1gys5hc-0"
})(["width:100vw;height:calc(100vh - 64px);box-sizing:border-box;display:", ";flex-direction:column;top:64px;left:0;position:absolute;z-index:11;background-color:", ";overflow-y:auto;padding:8px 16px 16px 16px;@media (min-width:", "){top:80px;padding:8px 24px 24px 24px;height:calc(100vh - 80px);}@media (min-width:", "){display:none;}"], function (_ref) {
  var $open = _ref.$open;
  return $open ? 'flex' : 'none';
}, Colors.white, breakpointSM, breakpointLG$1);

var MobilePanelContainer$1 = function MobilePanelContainer(_ref) {
  var mobilePanelDisplay = _ref.mobilePanelDisplay,
    children = _ref.children;
  useEffect(function () {
    if (typeof document !== 'undefined' && mobilePanelDisplay === true) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
    } else {
      document.body.style.overflow = '';
      document.body.style.height = '';
    }
  }, [mobilePanelDisplay]);
  return React__default.createElement(React__default.Fragment, null, mobilePanelDisplay ? React__default.createElement(Wrapper$l, {
    "$open": mobilePanelDisplay
  }, children) : null);
};

var StyledMuiAccordion$1 = /*#__PURE__*/styled(MuiAccordion).withConfig({
  displayName: "StyledMuiAccordion",
  componentId: "uh__sc-y79pkl-0"
})(["width:100%;border-radius:16px;border:1px solid ", ";margin-bottom:16px;& .main{padding:0 0 16px 0;}& .MuiCollapse-root{padding:0 16px 0 16px;& .MuiTypography-root{padding:8px;", ";}}.MuiCollapse-wrapper{padding-bottom:16px;}&:before{display:none;}"], Colors.cream100, button);
var StyledAccordionSummary$1 = /*#__PURE__*/styled(MuiAccordionSummary).withConfig({
  displayName: "StyledAccordionSummary",
  componentId: "uh__sc-y79pkl-1"
})(["padding:16px;& .MuiTypography-root{color:", ";", ";}& .MuiAccordionSummary-content{margin:0;}"], Colors.grey900, subTitle2);
var StyledAccordionDetails$1 = /*#__PURE__*/styled(MuiAccordionDetails).withConfig({
  displayName: "StyledAccordionDetails",
  componentId: "uh__sc-y79pkl-2"
})(["padding:0;"]);

var CustomAccordion$1 = function CustomAccordion(props) {
  return createElement(StyledMuiAccordion$1, Object.assign({
    disableGutters: true,
    elevation: 0,
    square: true
  }, props));
};
var CustomAccordionSummary$1 = function CustomAccordionSummary(props) {
  return createElement(StyledAccordionSummary$1, Object.assign({
    expandIcon: createElement(ArrowDown, {
      color: Colors.grey900
    })
  }, props));
};
var CustomAccordionDetails$1 = StyledAccordionDetails$1;

var Wrapper$m = /*#__PURE__*/styled.section.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1efyayx-0"
})(["width:100%;margin:0 auto;position:fixed;left:0;padding:16px;box-sizing:border-box;bottom:0;background-color:", ";display:flex;flex-direction:column;gap:8px;:before{content:'';position:absolute;left:16px;top:0;width:calc(100% - 32px);height:1px;background-color:", ";}@media (min-width:", "){flex-direction:row;justify-content:center;padding:24px;&:before{left:24px;width:calc(100% - 48px);}}@media (min-width:", "){display:none;}"], Colors.white, function (_ref) {
  var $type = _ref.$type;
  return $type === HEADER_TYPE$1.Integrated ? 'transparent' : Colors.grey200;
}, breakpointSM, breakpointLG$1);
var CustomLink$e = /*#__PURE__*/styled(StyledLinkV2).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-1efyayx-1"
})(["box-sizing:border-box;display:flex;align-items:center;justify-content:center;background-color:transparent;border:2px solid ", ";border-radius:12px;padding:8px;height:48px;min-width:76px;max-width:100%;", " &:hover{background-color:", ";color:", ";border:2px solid ", ";}&.MuiLink-root{&:focus,&:active{color:", ";background-color:", ";border:2px solid ", ";outline:2px solid ", ";outline-offset:-4px;}}@media (min-width:", "){max-width:300px;}"], Colors.blue300, button, Colors.blue400, Colors.grey900, Colors.blue400, Colors.grey900, Colors.blue300, Colors.blue300, Colors.white, breakpointSM);
var RegistrationLink$3 = /*#__PURE__*/styled(StyledLinkV2).withConfig({
  displayName: "RegistrationLink",
  componentId: "uh__sc-1efyayx-2"
})(["box-sizing:border-box;display:flex;align-items:center;justify-content:center;border:2px solid ", ";background-color:", ";border-radius:12px;padding:8px;height:48px;min-width:76px;max-width:100%;", " &:hover{background-color:", ";border:2px solid ", ";}&.MuiLink-root{&:focus,&:active{color:", ";border:2px solid ", ";outline:2px solid ", ";outline-offset:-4px;}}@media (min-width:", "){max-width:300px;}"], Colors.blue300, Colors.blue300, button, Colors.blue400, Colors.blue400, Colors.grey900, Colors.blue300, Colors.white, breakpointSM);

var BottomSection$1 = function BottomSection(_ref) {
  var actionItems = _ref.actionItems,
    headerType = _ref.headerType;
  return React__default.createElement(Wrapper$m, {
    "$type": headerType
  }, actionItems.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      href = _ref2.href,
      type = _ref2.type,
      callback = _ref2.callback;
    var props = {};
    if (href) {
      props.href = href;
    }
    return React__default.createElement(Fragment, {
      key: id
    }, type === ACTION_TYPE$1.Login ? React__default.createElement(CustomLink$e, Object.assign({}, props, {
      underline: "none"
    }), title) : React__default.createElement(RegistrationLink$3, Object.assign({}, props, {
      underline: "none",
      onClick: callback ? callback : undefined
    }), title));
  }));
};

var InfoSection$3 = /*#__PURE__*/styled('div').withConfig({
  displayName: "InfoSection",
  componentId: "uh__sc-xz8dje-0"
})({
  flex: 1,
  paddingBottom: 8,
  marginBottom: 16,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  borderBottom: "1px solid " + Colors.grey200
});
var Wrapper$n = /*#__PURE__*/styled('div').withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-xz8dje-2"
})({
  display: 'block',
  width: '100%'
});

var CustomerMenuContainer$3 = function CustomerMenuContainer(_ref) {
  var customer = _ref.customer;
  if (typeof customer === 'undefined') {
    return null;
  }
  var displayName = customer.displayName,
    fullName = customer.fullName,
    accountIds = customer.accountIds;
  return React__default.createElement(Wrapper$n, null, React__default.createElement(InfoSection$3, null, React__default.createElement(UserSection$1, {
    displayName: displayName,
    fullName: fullName,
    accountIds: accountIds
  })));
};

var CustomNav$3 = /*#__PURE__*/styled.nav.withConfig({
  displayName: "CustomNav",
  componentId: "uh__sc-h940r0-0"
})(["flex:1;display:", ";margin:0 0 210px 0;"], function (_ref) {
  var $type = _ref.$type;
  return $type === HEADER_TYPE$1.Integrated ? 'none' : 'initial';
});
var CustomSection$1 = /*#__PURE__*/styled.section.withConfig({
  displayName: "CustomSection",
  componentId: "uh__sc-h940r0-1"
})(["flex:1;"]);
var CustomLink$f = /*#__PURE__*/styled(StyledLinkV2).withConfig({
  displayName: "CustomLink",
  componentId: "uh__sc-h940r0-3"
})(["flex:1;display:flex;justify-content:space-between;align-items:center;color:", ";", ";&.MuiLink-root:hover,&.MuiLink-root:focus,&.MuiLink-root:active{color:", ";text-decoration:none;background:none;}.MuiSvgIcon-root{font-size:30px;}"], Colors.grey900, subTitle2, function (_ref2) {
  var $isActive = _ref2.$isActive;
  return $isActive ? Colors.blue400 : Colors.grey900;
});
var CustomBadge$3 = /*#__PURE__*/styled(Badge).withConfig({
  displayName: "CustomBadge",
  componentId: "uh__sc-h940r0-4"
})([".MuiBadge-badge{right:-8px;}"]);

var HEDER_TAG$1 = 'HEADER';
var MobilePanel$1 = function MobilePanel(_ref) {
  var type = _ref.type,
    navItems = _ref.navItems,
    customer = _ref.customer,
    actionItems = _ref.actionItems,
    setMobilePanelDisplay = _ref.setMobilePanelDisplay;
  var _useState = useState(''),
    expanded = _useState[0],
    setExpanded = _useState[1];
  var handleChange = function handleChange(id) {
    return function (event, newExpanded) {
      setExpanded(newExpanded ? id : false);
    };
  };
  var closeMobilePanel = function closeMobilePanel(e) {
    var target = e.target;
    if (target.tagName !== HEDER_TAG$1) {
      setMobilePanelDisplay(false);
    }
  };
  var computedActionItems = actionItems;
  if (customer) {
    var customerActionItems = customer.actionItems;
    computedActionItems = [_extends({}, customerActionItems[0], {
      type: ACTION_TYPE$1.Registration
    })];
  }
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(CustomerMenuContainer$3, {
    customer: customer
  }), React__default.createElement(CustomNav$3, {
    "$type": type
  }, React__default.createElement(CustomSection$1, null, navItems.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      subMenus = _ref2.subMenus,
      _ref2$enableBadge = _ref2.enableBadge,
      enableBadge = _ref2$enableBadge === void 0 ? false : _ref2$enableBadge,
      href = _ref2.href;
    var showBadge = enableBadge === true && (customer == null ? void 0 : customer.showUnreadMessage) === true;
    var isActive = getActiveStatus$1(subMenus, href);
    var mainHref = isEmpty(href) ? undefined : href;
    return React__default.createElement(CustomAccordion$1, {
      expanded: expanded === id,
      onChange: handleChange(id),
      key: id,
      id: id
    }, React__default.createElement(CustomAccordionSummary$1, {
      href: href
    }, React__default.createElement(CustomLink$f, {
      "$isActive": isActive,
      href: mainHref,
      underline: "none"
    }, React__default.createElement(CustomBadge$3, {
      variant: "dot",
      invisible: !showBadge,
      color: "error"
    }, title))), React__default.createElement(CustomAccordionDetails$1, null, React__default.createElement(SubMenuContainer$1, {
      subMenus: subMenus,
      clickCallback: closeMobilePanel
    })));
  }), customer != null && customer.subMenus ? React__default.createElement(CustomAccordion$1, {
    key: "account-mobile-menu",
    expanded: expanded === 'account-mobile-menu',
    onChange: handleChange('account-mobile-menu')
  }, React__default.createElement(CustomAccordionSummary$1, {
    href: undefined
  }, React__default.createElement(CustomLink$f, {
    "$isActive": undefined,
    href: undefined,
    underline: "none"
  }, React__default.createElement(ManageAccountsIcon, null))), React__default.createElement(CustomAccordionDetails$1, null, React__default.createElement(SubMenuSection$1, {
    items: customer.subMenus
  }))) : null)), computedActionItems ? React__default.createElement(BottomSection$1, {
    actionItems: computedActionItems,
    headerType: type
  }) : null);
};

var _styled$withConfig;
var BalanceContainer$2 = /*#__PURE__*/styled('div').withConfig({
  displayName: "BalanceContainer",
  componentId: "uh__sc-s58vzn-0"
})((_styled$withConfig = {
  width: '100%',
  padding: '8px 0 16px 0',
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: 64,
  height: 80,
  zIndex: 10,
  background: Colors.white,
  right: 0,
  margin: 0,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 32,
  borderBottomRightRadius: 32,
  boxSizing: 'border-box',
  borderLeft: "1px solid " + Colors.cream100,
  borderRight: "1px solid " + Colors.cream100,
  borderBottom: "1px solid " + Colors.cream100,
  '> div:last-of-type': {
    margin: '8px 0 0'
  }
}, _styled$withConfig["@media (min-width: " + breakpointSM + ")"] = {
  top: 80
}, _styled$withConfig["@media (min-width: " + breakpointMD + ")"] = {
  width: 'max-content',
  flexDirection: 'row',
  padding: '8px 16px 24px 16px',
  margin: '0 0 0 auto',
  height: 56,
  '> div:last-of-type': {
    margin: '0 0 0 0'
  }
}, _styled$withConfig["@media (min-width: " + breakpointLG$1 + ")"] = {
  padding: '16px 16px 24px 16px',
  margin: '0 24px 0 auto',
  height: 64
}, _styled$withConfig));
var BalanceItem$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "BalanceItem",
  componentId: "uh__sc-s58vzn-1"
})(["display:flex;padding:0 16px;gap:8px;@media (min-width:", "){padding:0 8px;}"], breakpointMD);
var BalanceLabel$1 = /*#__PURE__*/styled(Typography$1).withConfig({
  displayName: "BalanceLabel",
  componentId: "uh__sc-s58vzn-2"
})(["color:", ";", ";"], Colors.grey500, body1);
var negativeAmount$1 = /*#__PURE__*/css(["color:", ";background-color:", ";padding:2px 4px;"], Colors.error100, Colors.error10);
var AmountLabel$1 = /*#__PURE__*/styled.span.withConfig({
  displayName: "AmountLabel",
  componentId: "uh__sc-s58vzn-3"
})(["", ";color:", ";", ";"], button, Colors.grey900, function (_ref) {
  var $isNegative = _ref.$isNegative;
  return $isNegative && negativeAmount$1;
});

var StyledTooltip$1 = /*#__PURE__*/withStyles({
  tooltip: {
    color: Colors.black80,
    backgroundColor: Colors.white,
    borderRadius: '4px',
    boxShadow: '0 1px 8px 0 rgba(0, 0, 0, .10), 0px 2px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.15)',
    padding: '8px',
    fontSize: 14
  }
})(Tooltip$1);

var NotAvailableBalance$1 = function NotAvailableBalance(_ref) {
  var notAvailableMessage = _ref.notAvailableMessage;
  return React__default.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    spacing: 1
  }, React__default.createElement(StyledTooltip$1, {
    title: notAvailableMessage == null ? void 0 : notAvailableMessage.tooltipText,
    placement: "bottom-start"
  }, React__default.createElement(InfoOutlinedIcon, null)), React__default.createElement(Typography$1, {
    fontSize: 16,
    fontWeight: 600
  }, notAvailableMessage == null ? void 0 : notAvailableMessage.title));
};

function shouldShowBalance(_ref) {
  var type = _ref.type,
    state = _ref.state;
  return type === HEADER_TYPE.Private && state === 'ACTIVE';
}

var BalanceLabel$2 = function BalanceLabel(_ref) {
  var label = _ref.label,
    dataTestId = _ref.dataTestId;
  return label ? React__default.createElement(BalanceLabel$1, {
    "data-testid": dataTestId
  }, label, " ") : null;
};
var BalanceContainer$3 = function BalanceContainer(_ref2) {
  var _customer$totalBalanc, _customer$totalBalanc2, _customer$totalBalanc3, _customer$availableBa, _customer$availableBa2, _customer$availableBa3;
  var type = _ref2.type,
    customer = _ref2.customer;
  if (!shouldShowBalance({
    type: type,
    state: customer == null ? void 0 : customer.state
  })) return null;
  return React__default.createElement(BalanceContainer$2, null, React__default.createElement(BalanceItem$1, null, React__default.createElement(BalanceLabel$2, {
    label: customer == null ? void 0 : (_customer$totalBalanc = customer.totalBalance) == null ? void 0 : _customer$totalBalanc.label,
    dataTestId: "total-balance"
  }), customer != null && customer.balanceIsNotAvailable ? React__default.createElement(NotAvailableBalance$1, {
    notAvailableMessage: customer == null ? void 0 : customer.notAvailableMessage
  }) : React__default.createElement(AmountLabel$1, {
    "$isNegative": customer == null ? void 0 : (_customer$totalBalanc2 = customer.totalBalance) == null ? void 0 : _customer$totalBalanc2.isNegative
  }, customer == null ? void 0 : (_customer$totalBalanc3 = customer.totalBalance) == null ? void 0 : _customer$totalBalanc3.amount)), React__default.createElement(BalanceItem$1, null, React__default.createElement(BalanceLabel$2, {
    label: customer == null ? void 0 : (_customer$availableBa = customer.availableBalance) == null ? void 0 : _customer$availableBa.label,
    dataTestId: "available-balance"
  }), customer != null && customer.balanceIsNotAvailable ? React__default.createElement(NotAvailableBalance$1, {
    notAvailableMessage: customer == null ? void 0 : customer.notAvailableMessage
  }) : React__default.createElement(AmountLabel$1, {
    "$isNegative": customer == null ? void 0 : (_customer$availableBa2 = customer.availableBalance) == null ? void 0 : _customer$availableBa2.isNegative
  }, customer == null ? void 0 : (_customer$availableBa3 = customer.availableBalance) == null ? void 0 : _customer$availableBa3.amount)));
};

var Wrapper$o = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "uh__sc-1nzra08-0"
})(["position:relative;box-sizing:border-box;background-color:", ";padding-bottom:", ";@media (min-width:", "){padding-bottom:", ";}@media (min-width:", "){padding-bottom:", ";}"], Colors.background, function (_ref) {
  var $addPadding = _ref.$addPadding;
  return $addPadding ? '88px' : 0;
}, breakpointMD, function (_ref2) {
  var $addPadding = _ref2.$addPadding;
  return $addPadding ? '64px' : 0;
}, breakpointLG$1, function (_ref3) {
  var $addPadding = _ref3.$addPadding;
  return $addPadding ? '72px' : 0;
});
var Container$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "uh__sc-1nzra08-1"
})(["position:relative;box-sizing:border-box;background-color:", ";&.navWrapper:after{content:'';position:absolute;width:100%;height:1px;background:", ";display:flex;align-items:center;right:0;left:0;top:64px;z-index:9;}@media (min-width:", "){&.navWrapper:after{top:80px;}}@media (min-width:", "){padding:0 24px;}"], Colors.white, Colors.cream100, breakpointSM, breakpointLG$1);
var CustomHeader$1 = /*#__PURE__*/styled.header.withConfig({
  displayName: "CustomHeader",
  componentId: "uh__sc-1nzra08-2"
})(["max-width:1320px;height:100%;margin:0 auto;position:relative;"]);
var SectionWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "SectionWrapper",
  componentId: "uh__sc-1nzra08-3"
})(["display:flex;align-items:center;justify-content:", ";"], function (_ref4) {
  var $type = _ref4.$type,
    $hasDataSource = _ref4.$hasDataSource;
  return $type === HEADER_TYPE$1.Private || !$hasDataSource ? 'space-between' : 'flex-start';
});
var TopNav$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "TopNav",
  componentId: "uh__sc-1nzra08-4"
})(["display:flex;align-items:center;padding:0 16px;justify-content:space-between;min-height:64px;@media (min-width:", "){min-height:80px;padding:0 24px;}@media (min-width:", "){justify-content:space-between;padding:0 24px;}"], breakpointSM, breakpointLG$1);

var DefaultSkeleton$1 = function DefaultSkeleton() {
  return React__default.createElement(Wrapper$o, {
    className: "navWrapper",
    "aria-label": "loading nav"
  }, React__default.createElement(CustomHeader$1, null, React__default.createElement(TopNav$1, null, React__default.createElement(SectionWrapper$1, {
    "$hasDataSource": false
  }, React__default.createElement(Skeleton$2, {
    variant: "rounded",
    width: 120,
    height: 24
  }), React__default.createElement(Skeleton$2, {
    variant: "rounded",
    width: 24,
    height: 24
  })))));
};
var UnifiedNavigation$1 = function UnifiedNavigation(_ref) {
  var dataSource = _ref.dataSource;
  var _useState = useState(false),
    mobilePanelDisplay = _useState[0],
    setMobilePanelDisplay = _useState[1];
  if (!dataSource) {
    return React__default.createElement(DefaultSkeleton$1, null);
  }
  var type = dataSource.type,
    logoItems = dataSource.logoItems,
    navItems = dataSource.navItems,
    actionItems = dataSource.actionItems,
    customer = dataSource.customer,
    isHeaderDataLoading = dataSource.isHeaderDataLoading;
  var shouldShowPrivateLoader = type === HEADER_TYPE$1.Private && isHeaderDataLoading;
  var shouldAddPadding = shouldShowBalance({
    type: type,
    state: customer == null ? void 0 : customer.state
  });
  return React__default.createElement(ThemeProvider, {
    theme: theme$1
  }, React__default.createElement(Wrapper$o, {
    "$addPadding": shouldAddPadding
  }, React__default.createElement(Container$2, {
    className: "navWrapper"
  }, React__default.createElement(CustomHeader$1, null, React__default.createElement(TopNav$1, null, React__default.createElement(SectionWrapper$1, {
    "$type": type,
    "$hasDataSource": true
  }, React__default.createElement(LogoSection$1, {
    logoItems: logoItems
  })), navItems ? React__default.createElement(Navigation$1, {
    type: type,
    navItems: navItems,
    customer: customer,
    shouldShowPrivateLoader: shouldShowPrivateLoader
  }) : null, actionItems && type !== HEADER_TYPE$1.Private ? React__default.createElement(ActionsSection$1, {
    actionItems: actionItems
  }) : null, navItems ? React__default.createElement(HamburgerSection$1, {
    mobilePanelDisplay: mobilePanelDisplay,
    setMobilePanelDisplay: setMobilePanelDisplay,
    shouldShowPrivateLoader: shouldShowPrivateLoader
  }) : null), React__default.createElement(BalanceContainer$3, {
    type: type,
    customer: customer
  })), navItems ? React__default.createElement(MobilePanelContainer$1, {
    mobilePanelDisplay: mobilePanelDisplay
  }, React__default.createElement(MobilePanel$1, {
    type: type,
    navItems: navItems,
    customer: customer,
    actionItems: actionItems,
    setMobilePanelDisplay: setMobilePanelDisplay
  })) : null)));
};

export { LogoutCountdown, UnifiedNavigation, UnifiedNavigation$1 as UnifiedNavigationV2 };
//# sourceMappingURL=unified-header.esm.js.map
